/*eslint-disable*/

/*
This file is auto-generated by svg-list
https://github.com/psoaresbj/svg-list
*/

const ui = {
  twitter: {
    viewbox: '0 0 32 32',
    paths: [
      {
        d: 'M0 16C0 7.2 7.2 0 16 0s16 7.2 16 16-7.2 16-16 16S0 24.8 0 16zm23.3-3.1v-.5c.7-.5 1.3-1.2 1.8-1.9-.7.3-1.4.5-2.1.6.8-.5 1.3-1.2 1.6-2-.7.4-1.5.7-2.3.9-.7-.7-1.6-1.2-2.7-1.2-2 0-3.7 1.6-3.7 3.7 0 .3 0 .6.1.8-3.1-.2-5.8-1.6-7.6-3.8-.2.6-.4 1.2-.4 1.9 0 1.3.6 2.4 1.6 3.1-.6-.1-1.1-.3-1.6-.5 0 1.8 1.3 3.3 2.9 3.6-.3.1-.6.1-1 .1-.2 0-.5 0-.7-.1.5 1.5 1.8 2.5 3.4 2.6-1.3 1-2.8 1.6-4.6 1.6-.3 0-.6 0-.9-.1 1.6 1 3.6 1.6 5.6 1.6 6.9.1 10.6-5.5 10.6-10.4z',
      },
    ],
  },
  alertCircle: {
    viewbox: '0 0 20 20',
    paths: [
      {
        d: 'M10 20C4.5 20 0 15.5 0 10S4.5 0 10 0s10 4.5 10 10-4.5 10-10 10zm0-18.2c-4.5 0-8.2 3.7-8.2 8.2s3.7 8.2 8.2 8.2 8.2-3.7 8.2-8.2-3.7-8.2-8.2-8.2zm0 12.7c-.5 0-.9-.4-.9-.9s.4-.9.9-.9.9.4.9.9-.4.9-.9.9zm0-3.6c-.5 0-.9-.4-.9-.9V6.4c0-.5.4-.9.9-.9s.9.4.9.9V10c0 .5-.4.9-.9.9z',
      },
    ],
  },
  alertTriangle: {
    viewbox: '0 0 20 20',
    paths: [
      {
        d: 'M2.6 18.8c-.5 0-.9-.1-1.3-.4-.4-.2-.7-.6-.9-1s-.4-.8-.4-1.3.1-.9.4-1.3L7.8 2.5c.2-.4.6-.7 1-.9.8-.4 1.8-.4 2.6 0 .4.2.7.5 1 .9l7.4 12.4c.2.4.4.9.4 1.3 0 .5-.1.9-.3 1.3-.2.4-.6.7-.9 1-.4.2-.8.4-1.3.4H2.6zM9.3 3.4 1.9 15.7c-.1.1-.1.3-.1.4 0 .2 0 .3.1.4l.3.3c.1.2.3.2.4.2h14.8c.1 0 .3 0 .4-.1l.3-.3c.1-.1.1-.3.1-.4 0-.2 0-.3-.1-.4L10.7 3.4l-.3-.3c-.3-.1-.6-.1-.9 0-.1 0-.2.2-.2.3zm.7 11.9c-.5 0-.9-.4-.9-.9s.4-.9.9-.9.9.4.9.9-.4.9-.9.9zm0-3.5c-.5 0-.9-.4-.9-.9V7.4c0-.5.4-.9.9-.9s.9.4.9.9v3.5c0 .5-.4.9-.9.9z',
      },
    ],
  },
  arrowDown: {
    viewbox: '0 0 20 20',
    paths: [
      {
        d: 'M16.6 10.1c0 .2-.1.4-.2.6l-5.8 5.8c-.1.1-.2.1-.3.2-.1 0-.2.1-.3.1s-.2 0-.3-.1c-.1 0-.2-.1-.2-.2l-5.8-5.8c-.3-.3-.3-.9 0-1.2s.9-.3 1.2 0l4.2 4.4V4.2c0-.5.4-.8.8-.8s.8.4.8.8v9.7l4.4-4.4c.3-.3.9-.3 1.2 0 .2.2.3.4.3.6z',
      },
    ],
  },
  arrowLeft: {
    viewbox: '0 0 20 20',
    paths: [
      {
        d: 'M10 16.7c-.2 0-.4-.1-.6-.2l-5.8-5.8c-.1-.1-.1-.2-.2-.3 0-.1-.1-.2-.1-.3 0-.1 0-.2.1-.3 0-.1.1-.2.2-.2l5.8-5.8c.3-.3.9-.3 1.2 0s.3.9 0 1.2L6.2 9.2h9.7c.5 0 .8.4.8.8s-.4.8-.8.8H6.2l4.4 4.4c.3.3.3.9 0 1.2-.2.2-.4.3-.6.3z',
      },
    ],
  },
  arrowRight: {
    viewbox: '0 0 20 20',
    paths: [
      {
        d: 'M10 3.6c.2 0 .4.1.6.2l5.8 5.8c.1.1.1.2.2.3 0 .1.1.2.1.3s0 .2-.1.3c0 .1-.1.2-.2.2l-5.8 5.8c-.3.3-.9.3-1.2 0-.3-.3-.3-.9 0-1.2l4.4-4.2H4.1c-.5 0-.8-.4-.8-.8s.4-.8.8-.8h9.7L9.4 5.1c-.3-.3-.3-.9 0-1.2.2-.2.4-.3.6-.3z',
      },
    ],
  },
  arrowUp: {
    viewbox: '0 0 20 20',
    paths: [
      {
        d: 'M3.4 10.1c0-.2.1-.4.2-.6l5.8-5.8c.1-.1.2-.1.3-.2.1 0 .2-.1.3-.1s.2 0 .3.1c.1 0 .2.1.2.2l5.8 5.8c.3.3.3.9 0 1.2-.3.3-.9.3-1.2 0l-4.2-4.4V16c0 .5-.4.8-.8.8s-.8-.4-.8-.8V6.3l-4.4 4.4c-.3.3-.9.3-1.2 0-.2-.2-.3-.4-.3-.6z',
      },
    ],
  },
  bank: {
    viewbox: '0 0 23 23',
    paths: [
      {
        fillRule: 'evenodd',
        clipRule: 'evenodd',
        d: 'M11.53 1.835a.333.333 0 0 0-.06 0c-.009 0-.023.002-.194.04L2.643 3.793c-.273.061-.434.097-.552.133a.601.601 0 0 0-.12.044c-.001.001 0 .001 0 0a.333.333 0 0 0-.11.14c0-.003 0-.003 0 0a.6.6 0 0 0-.018.125c-.01.123-.01.288-.01.567v1.303c0 .34.001.545.013.698a.68.68 0 0 0 .024.154.333.333 0 0 0 .144.144.68.68 0 0 0 .154.024c.153.013.358.013.699.013h17.266c.34 0 .546 0 .699-.013a.682.682 0 0 0 .154-.024.333.333 0 0 0 .144-.144.68.68 0 0 0 .024-.154c.012-.152.013-.358.013-.698V4.802c0-.279 0-.444-.01-.567a.614.614 0 0 0-.017-.126c-.001-.002-.001-.002 0 0a.333.333 0 0 0-.112-.139c.007.005-.01-.011-.118-.044a8.779 8.779 0 0 0-.552-.133l-8.634-1.918a2.208 2.208 0 0 0-.195-.04ZM20.987 7.1h-.002ZM1.87 6.959v-.002ZM11.325.174a2 2 0 0 1 .35 0c.132.012.26.04.382.068l.029.006 8.658 1.924c.24.053.46.102.645.158.201.06.412.143.613.288a2 2 0 0 1 .67.833c.097.229.132.452.147.662.014.192.014.418.014.664v1.357c0 .302 0 .576-.018.805-.02.246-.066.512-.2.774a2 2 0 0 1-.874.874c-.261.133-.527.18-.773.2-.14.01-.298.015-.468.017v7.669c.17.001.327.006.468.017.246.02.512.066.773.2a2 2 0 0 1 .874.873c.134.262.18.528.2.774.018.23.018.504.018.805v.992c0 .302 0 .576-.018.805-.02.246-.066.512-.2.774a2 2 0 0 1-.874.874c-.261.133-.527.18-.773.2-.23.018-.504.018-.805.018H2.837c-.301 0-.576 0-.804-.019a2.027 2.027 0 0 1-.774-.2 2 2 0 0 1-.874-.873 2.028 2.028 0 0 1-.2-.774c-.018-.229-.018-.503-.018-.805v-.992c0-.301 0-.576.018-.805.02-.246.066-.512.2-.773a2 2 0 0 1 .874-.875c.262-.133.527-.179.774-.199.14-.011.297-.016.467-.017v-7.67a6.706 6.706 0 0 1-.467-.017 2.029 2.029 0 0 1-.774-.2 2 2 0 0 1-.874-.873 2.029 2.029 0 0 1-.2-.774C.167 6.71.167 6.436.167 6.134V4.777c0-.246 0-.472.014-.664.015-.21.05-.433.148-.662a2 2 0 0 1 .669-.833c.201-.145.412-.228.613-.288.184-.056.406-.105.645-.158l.025-.005L10.914.248l.03-.006c.121-.028.248-.056.381-.068Zm-7.158 8.63v7.667H7.75V8.805H4.167Zm5.25 0v7.667h4.166V8.805H9.417Zm5.833 0v7.667h3.583V8.805H15.25ZM2.867 18.139c-.34 0-.546 0-.699.013a.683.683 0 0 0-.154.024.333.333 0 0 0-.144.144.68.68 0 0 0-.024.154 9.755 9.755 0 0 0-.013.699v.933c0 .34.001.546.013.698.01.106.021.145.024.154a.333.333 0 0 0 .144.144.677.677 0 0 0 .154.024c.153.012.358.013.699.013h17.266c.34 0 .546 0 .699-.013a.677.677 0 0 0 .154-.024.334.334 0 0 0 .144-.144.69.69 0 0 0 .024-.154c.012-.152.013-.358.013-.698v-.933c0-.34-.001-.546-.013-.699a.69.69 0 0 0-.024-.154.334.334 0 0 0-.144-.144.677.677 0 0 0-.154-.024 9.748 9.748 0 0 0-.699-.013H2.867Zm18.12 2.962-.001.001Zm-19.116-.14v-.003Zm.141-2.784.002-.001Z',
      },
    ],
  },
  barChart2: {
    viewbox: '0 0 18 18',
    paths: [
      {
        d: 'M15 18c-.6 0-1-.4-1-1V1c0-.6.4-1 1-1s1 .4 1 1v16c0 .6-.4 1-1 1zm-6 0c-.6 0-1-.4-1-1V7c0-.6.4-1 1-1s1 .4 1 1v10c0 .6-.4 1-1 1zm-6 0c-.6 0-1-.4-1-1v-4c0-.6.4-1 1-1s1 .4 1 1v4c0 .6-.4 1-1 1z',
      },
    ],
  },
  barChart: {
    viewbox: '0 0 24 24',
    paths: [
      {
        d: 'M18 21c-.6 0-1-.4-1-1V10c0-.6.4-1 1-1s1 .4 1 1v10c0 .6-.4 1-1 1zm-6 0c-.6 0-1-.4-1-1V4c0-.6.4-1 1-1s1 .4 1 1v16c0 .6-.4 1-1 1zm-6 0c-.6 0-1-.4-1-1v-6c0-.6.4-1 1-1s1 .4 1 1v6c0 .6-.4 1-1 1z',
      },
    ],
  },
  bell: {
    viewbox: '0 0 24 24',
    paths: [
      {
        d: 'M14.6 21.5c-.3.5-.6.8-1.1 1.1-.5.3-1 .4-1.5.4s-1-.1-1.5-.4c-.5-.3-.8-.6-1.1-1.1-.3-.5-.1-1.1.4-1.4.5-.3 1.1-.1 1.4.4.1.2.2.3.4.4.3.2.7.2 1 0 .2-.1.3-.2.4-.4.3-.5.9-.6 1.4-.4.3.3.5.9.2 1.4zm7.3-4.2c-.1.4-.5.7-.9.7H3c-.4 0-.8-.3-1-.7-.1-.4 0-.9.4-1.1 0 0 2.6-1.9 2.6-8.2 0-1.9.7-3.6 2.1-4.9C8.4 1.7 10.1 1 12 1s3.6.7 4.9 2.1C18.3 4.4 19 6.1 19 8c0 6.3 2.5 8.2 2.6 8.2.3.2.5.7.3 1.1zm-3-1.3C18 14.5 17 12 17 8c0-1.3-.5-2.6-1.5-3.5-.9-1-2.2-1.5-3.5-1.5-1.3 0-2.6.5-3.5 1.5C7.5 5.4 7 6.7 7 8c0 4-1 6.5-1.9 8h13.8z',
      },
    ],
  },
  bookOpen: {
    viewbox: '0 0 24 24',
    paths: [
      {
        d: 'M12 22c-.6 0-1-.4-1-1 0-.5-.2-1-.6-1.4-.4-.4-.9-.6-1.4-.6H2c-.6 0-1-.4-1-1V3c0-.6.4-1 1-1h6c1.3 0 2.6.5 3.5 1.5.2.1.4.3.5.5.1-.2.3-.4.5-.5.9-1 2.2-1.5 3.5-1.5h6c.6 0 1 .4 1 1v15c0 .6-.4 1-1 1h-7c-.5 0-1 .2-1.4.6s-.6.9-.6 1.4c0 .6-.4 1-1 1zm-9-5h6c.7 0 1.4.2 2 .5V7c0-.8-.3-1.6-.9-2.1C9.6 4.3 8.8 4 8 4H3v13zM13 7v10.5c.6-.3 1.3-.5 2-.5h6V4h-5c-.8 0-1.6.3-2.1.9-.6.5-.9 1.3-.9 2.1z',
      },
    ],
  },
  box: {
    viewbox: '0 0 20 20',
    paths: [
      {
        d: 'M8.7.4C9.1.1 9.5 0 10 0s.9.1 1.3.4L17.6 4c1.3.7 1.4 1.9 1.4 2.3v7.2c0 .5-.1.9-.4 1.4-.2.4-.6.8-1 1l-6.3 3.6c-1.4.7-1.8.5-2.6.1L2.4 16c-.4-.2-.8-.6-1-1-.2-.4-.4-.9-.4-1.4V6.3C1 5.9 1 4.8 2.3 4l2.9-1.7.6-.3L8.7.4zM6 4 3.7 5.3 10 8.9l2.3-1.3L6 4zm8.1 2.6L7.8 2.9l1.7-1c.4-.3.7-.2 1 0l5.8 3.3-2.2 1.4zm3.1.2-6.3 3.7v7.2l5.9-3.4c.4-.2.4-.5.4-.8V6.8zM9.1 17.7v-7.2L2.8 6.8v6.8c0 .6.3.7.4.8l5.9 3.3z',
      },
    ],
  },
  briefcase: {
    viewbox: '0 0 22 20',
    paths: [
      {
        fillRule: 'evenodd',
        clipRule: 'evenodd',
        d: 'M6.879.879A3 3 0 0 1 9 0h4a3 3 0 0 1 3 3v1h3a3 3 0 0 1 3 3v10a3 3 0 0 1-3 3H3a3 3 0 0 1-3-3V7a3 3 0 0 1 3-3h3V3A3 3 0 0 1 6.879.879ZM6 6H3a1 1 0 0 0-1 1v10a1 1 0 0 0 1 1h3V6Zm2 12V6h6v12H8Zm8 0h3a1 1 0 0 0 1-1V7a1 1 0 0 0-1-1h-3v12ZM14 4H8V3a1 1 0 0 1 1-1h4a1 1 0 0 1 1 1v1Z',
      },
    ],
  },
  calendarCheck: {
    viewbox: '0 0 23 26',
    paths: [
      {
        fillRule: 'evenodd',
        clipRule: 'evenodd',
        d: 'M6.833.167c.46 0 .834.373.834.833v1.5h7.666V1A.833.833 0 1 1 17 1v1.5c.694.002 1.276.01 1.767.05.635.052 1.189.162 1.7.422a4.333 4.333 0 0 1 1.894 1.894c.26.511.37 1.066.422 1.7.05.618.05 1.382.05 2.331v9.872c0 .95 0 1.713-.05 2.331-.052.635-.161 1.19-.422 1.7a4.333 4.333 0 0 1-1.894 1.894c-.511.261-1.065.37-1.7.422-.618.05-1.381.05-2.331.05H6.564c-.95 0-1.713 0-2.33-.05-.636-.052-1.19-.161-1.701-.422a4.334 4.334 0 0 1-1.894-1.893c-.26-.512-.37-1.066-.422-1.701-.05-.618-.05-1.381-.05-2.33V8.897c0-.95 0-1.714.05-2.331.052-.635.161-1.19.422-1.7a4.333 4.333 0 0 1 1.894-1.895c.511-.26 1.065-.37 1.7-.422.49-.04 1.073-.048 1.767-.05V1c0-.46.373-.833.833-.833Zm-.833 4c-.685.002-1.205.01-1.63.045-.533.043-.843.124-1.08.245-.502.256-.91.664-1.166 1.166-.12.237-.202.547-.246 1.08-.044.541-.045 1.237-.045 2.23V9.5h19.334v-.567c0-.993-.001-1.689-.045-2.23-.044-.533-.125-.843-.246-1.08a2.667 2.667 0 0 0-1.165-1.166c-.238-.12-.548-.202-1.08-.245A21.85 21.85 0 0 0 17 4.167v1.5a.833.833 0 0 1-1.667 0v-1.5H7.667v1.5a.833.833 0 0 1-1.667 0v-1.5Zm15.167 7H1.833v7.566c0 .994.001 1.69.045 2.231.044.532.125.843.246 1.08.256.502.664.91 1.165 1.165.238.121.548.203 1.08.246.542.044 1.237.045 2.231.045h9.8c.994 0 1.69 0 2.231-.045.532-.043.842-.125 1.08-.246.501-.255.91-.663 1.165-1.165.12-.237.202-.548.246-1.08.044-.541.045-1.237.045-2.23v-7.567Zm-4.994 2.66a.833.833 0 0 1 0 1.179l-5.25 5.25a.833.833 0 0 1-1.179 0l-2.333-2.333a.833.833 0 1 1 1.178-1.179l1.744 1.744 4.661-4.66a.833.833 0 0 1 1.179 0Z',
      },
    ],
  },
  cardsStack: {
    viewbox: '0 0 22 22',
    paths: [
      {
        d: 'M10.553.106a1 1 0 0 1 .894 0l10 5a1 1 0 0 1 0 1.788l-10 5a1 1 0 0 1-.894 0l-10-5a1 1 0 0 1 0-1.788l10-5ZM3.236 6 11 9.882 18.764 6 11 2.118 3.236 6Zm-3.13 4.553a1 1 0 0 1 1.341-.447L11 14.882l9.553-4.776a1 1 0 1 1 .894 1.788l-10 5a1 1 0 0 1-.894 0l-10-5a1 1 0 0 1-.447-1.341Zm0 5a1 1 0 0 1 1.341-.447L11 19.882l9.553-4.776a1 1 0 1 1 .894 1.788l-10 5a1 1 0 0 1-.894 0l-10-5a1 1 0 0 1-.447-1.341Z',
      },
    ],
  },
  chat: {
    viewbox: '0 0 20 20',
    paths: [
      {
        d: 'M1 20c-.3 0-.5-.1-.7-.3-.3-.3-.4-.7-.2-1l1.8-5.3c-.6-1.2-.9-2.6-.9-3.9 0-1.8.5-3.5 1.4-5C3.3 3 4.7 1.8 6.3 1 7.6.3 9 0 10.5 0h.5c2.4.1 4.6 1.1 6.2 2.8C18.9 4.5 19.8 6.6 20 9v.6c0 1.5-.3 2.9-1 4.3-.8 1.6-2 2.9-3.5 3.8-1.5.9-3.2 1.4-5 1.4-1.3 0-2.6-.3-3.8-.8l-5.3 1.8c-.2-.1-.3-.1-.4-.1zm9.5-18c-1.2 0-2.3.3-3.3.8-1.3.6-2.3 1.6-3 2.8C3.4 6.7 3 8.1 3 9.5c0 1.2.3 2.3.8 3.3.1.2.1.5.1.8l-1.3 3.8 3.8-1.3c.3-.1.5-.1.8.1 1 .5 2.2.8 3.3.8 1.4 0 2.8-.4 3.9-1.1 1.2-.7 2.1-1.8 2.8-3 .5-1 .8-2.2.8-3.4V9c-.1-1.8-.9-3.5-2.2-4.8-1.3-1.3-3-2.1-4.9-2.2h-.4z',
      },
    ],
  },
  checkBold: {
    viewbox: '0 0 24 24',
    paths: [
      {
        d: 'M8.3 20.9c-.5 0-1.1-.2-1.5-.6L.6 14.1c-.8-.8-.8-2.2 0-3 .8-.8 2.2-.8 3 0l4.7 4.7L20.4 3.7c.8-.8 2.2-.8 3 0s.8 2.2 0 3L9.8 20.3c-.4.4-1 .6-1.5.6z',
      },
    ],
  },
  checkCircle: {
    viewbox: '0 0 20 20',
    paths: [
      {
        d: 'M10 19.1c-1.1 0-2.1-.2-3.2-.6-1.8-.7-3.4-1.9-4.5-3.6S.7 11.3.9 9.4s.9-3.8 2.2-5.3 3-2.5 4.9-3c1.9-.4 3.9-.2 5.7.6.4.2.5.6.4 1-.2.4-.6.5-1 .4-1.5-.7-3.2-.8-4.8-.5-1.6.4-3 1.2-4.1 2.5-1 1.2-1.7 2.8-1.8 4.4-.1 1.6.3 3.3 1.2 4.6.9 1.4 2.2 2.4 3.7 3 1.5.6 3.2.6 4.8.2 1.6-.5 3-1.4 3.9-2.7 1-1.3 1.5-2.9 1.5-4.5v-.9c0-.4.3-.8.8-.8s.8.3.8.8v.8c0 1.9-.6 3.9-1.8 5.4s-2.8 2.7-4.7 3.3c-.9.3-1.7.4-2.6.4zm0-6.7c-.2 0-.4-.1-.5-.2L7 9.7c-.3-.3-.3-.8 0-1.1s.8-.3 1.1 0l2 2 7.8-7.8c.3-.3.8-.3 1.1 0 .3.3.3.8 0 1.1l-8.3 8.3c-.3.1-.5.2-.7.2z',
      },
    ],
  },
  checkSquare: {
    viewbox: '0 0 21 20',
    paths: [
      {
        d: 'M3 2a1 1 0 0 0-1 1v14a1 1 0 0 0 1 1h14a1 1 0 0 0 1-1v-7a1 1 0 1 1 2 0v7a3 3 0 0 1-3 3H3a3 3 0 0 1-3-3V3a3 3 0 0 1 3-3h11a1 1 0 1 1 0 2H3Zm16.293-.707a1 1 0 1 1 1.414 1.414l-10 10a1 1 0 0 1-1.414 0l-3-3a1 1 0 0 1 1.414-1.414L10 10.586l9.293-9.293Z',
      },
    ],
  },
  check: {
    viewbox: '0 0 20 20',
    paths: [
      {
        d: 'M7.5 14.9c-.2 0-.4-.1-.5-.2l-4.2-4.2c-.3-.3-.3-.8 0-1.1s.8-.3 1.1 0L7.5 13l8.6-8.6c.3-.3.8-.3 1.1 0s.3.8 0 1.1L8 14.7c-.1.1-.3.2-.5.2z',
      },
    ],
  },
  chevronDown: {
    viewbox: '0 0 20 20',
    paths: [
      {
        d: 'M10 13.3c-.2 0-.4-.1-.6-.2l-5-5c-.3-.3-.3-.9 0-1.2s.9-.3 1.2 0l4.4 4.4 4.4-4.4c.3-.3.9-.3 1.2 0s.3.9 0 1.2l-5 5c-.2.2-.4.2-.6.2z',
      },
    ],
  },
  chevronRight: {
    viewbox: '0 0 20 20',
    paths: [
      {
        d: 'M7.5 15.8c-.2 0-.4-.1-.6-.2-.3-.3-.3-.9 0-1.2l4.4-4.4-4.4-4.4c-.3-.3-.3-.9 0-1.2s.9-.3 1.2 0l5 5c.3.3.3.9 0 1.2l-5 5c-.2.2-.4.2-.6.2z',
      },
    ],
  },
  chevronUp: {
    viewbox: '0 0 20 20',
    paths: [
      {
        d: 'M15 13.3c-.2 0-.4-.1-.6-.2L10 8.7l-4.4 4.4c-.3.3-.9.3-1.2 0s-.3-.9 0-1.2l5-5c.3-.3.9-.3 1.2 0l5 5c.3.3.3.9 0 1.2-.2.2-.4.2-.6.2z',
      },
    ],
  },
  clock: {
    viewbox: '0 0 20 20',
    paths: [
      {
        d: 'M10 19.1C5 19.1.9 15 .9 10S5 .9 10 .9 19.1 5 19.1 10 15 19.1 10 19.1zm0-16.7c-4.2 0-7.6 3.4-7.6 7.6s3.4 7.6 7.6 7.6 7.6-3.4 7.6-7.6-3.4-7.6-7.6-7.6zm3.3 10c-.1 0-.2 0-.3-.1l-3.3-1.7c-.3-.1-.4-.4-.4-.7V5c0-.4.3-.8.8-.8s.8.3.8.8v4.5l2.9 1.5c.4.2.5.6.3 1-.2.3-.5.4-.8.4z',
      },
    ],
  },
  close: {
    viewbox: '0 0 20 20',
    paths: [
      {
        d: 'M15 15.8c-.2 0-.4-.1-.6-.2L10 11.2l-4.4 4.4c-.3.3-.9.3-1.2 0-.3-.3-.3-.9 0-1.2L8.8 10 4.4 5.6c-.3-.3-.3-.9 0-1.2.3-.3.9-.3 1.2 0L10 8.8l4.4-4.4c.3-.3.9-.3 1.2 0 .3.3.3.9 0 1.2L11.2 10l4.4 4.4c.3.3.3.9 0 1.2-.2.2-.4.2-.6.2z',
      },
    ],
  },
  codepen: {
    viewbox: '0 0 24 24',
    paths: [
      {
        d: 'M12 23h-.3c-.1 0-.1 0-.2-.1 0 0-.1 0-.1-.1l-10-6.5c-.1 0-.1-.1-.2-.1-.1-.1-.1-.2-.2-.2 0-.1-.1-.1-.1-.2V8.2c0-.1 0-.1.1-.2 0-.1.1-.2.2-.2.1-.1.1-.1.2-.1l10-6.5s.1 0 .1-.1c.1 0 .1-.1.2-.1h.6c.1 0 .1 0 .2.1 0 0 .1 0 .1.1l10 6.5c.1 0 .1.1.2.1.1.1.1.2.2.2 0 .1.1.1.1.2v7.6c0 .1 0 .1-.1.2 0 .1-.1.2-.2.2s-.1.1-.2.1l-10 6.5s-.1 0-.1.1c-.1 0-.1.1-.2.1H12zm1-7v4.1l7.2-4.7-3.2-2.2-4 2.8zm-9.2-.5 7.2 4.7V16l-4-2.8-3.2 2.3zM8.7 12l3.3 2.3 3.3-2.3L12 9.7 8.7 12zm10 0 2.3 1.6v-3.2L18.7 12zM3 10.4v3.2L5.3 12 3 10.4zM13 8l4 2.8 3.2-2.2L13 3.8V8zm-9.2.5L7 10.8 11 8V3.8L3.8 8.5z',
      },
    ],
  },
  coinStack: {
    viewbox: '0 0 24 24',
    paths: [
      {
        d: 'M17 23c-1.5 0-3.1-.6-4.3-1.8-.3-.3-.5-.6-.7-.9-1 .3-2.2.4-3.4.4-3.2 0-6.6-1-6.6-3.2V4.2C2 2 5.4 1 8.6 1c1.6 0 3.2.3 4.3.7 1.9.8 2.2 1.8 2.3 2.4v7.1c2.1-.6 4.4-.1 6.1 1.5 1.1 1.1 1.8 2.6 1.8 4.2s-.6 3.1-1.8 4.2A5.86 5.86 0 0 1 17 23zm-3.6-4.2c.2.4.4.7.7 1 1.6 1.6 4.1 1.6 5.7 0C20.6 19 21 18 21 17c0-1.1-.4-2.1-1.2-2.8-1.4-1.4-3.5-1.5-5-.5 0 0-.1 0-.1.1-.2.1-.4.3-.6.5-.8.8-1.2 1.8-1.2 2.8 0 .6.1 1.1.4 1.6 0 0 .1 0 .1.1zM4 15.5v2c.1.3 1.7 1.2 4.6 1.2.9 0 1.8-.1 2.5-.3-.1-.5-.2-1-.2-1.5 0-.3 0-.6.1-.9-2.2.5-5.1.4-7-.5zm0-2.4c.1.4 1.7 1.3 4.6 1.3 1.2 0 2.3-.2 3.2-.5.2-.4.5-.8.9-1.1.2-.1.3-.3.5-.4v-1.3c-2.5 1.1-6.7 1.1-9.2 0v2zm0-4.4c.1.3 1.7 1.2 4.6 1.2 2.9 0 4.5-.9 4.6-1.2v-2c-2.5 1.1-6.7 1.1-9.2 0v2c0-.1 0-.1 0 0zm0 0zm0-4.5c.2.4 1.7 1.2 4.6 1.2s4.4-.9 4.6-1.2C13 3.9 11.4 3 8.6 3 5.7 3 4.2 3.9 4 4.2z',
      },
    ],
  },
  coinsHand: {
    viewbox: '0 0 26 26',
    paths: [
      {
        fillRule: 'evenodd',
        clipRule: 'evenodd',
        d: 'M3.17 13.55H4.163c.301 0 .576 0 .804.018.247.02.512.066.774.2a2 2 0 0 1 .874.873c.134.262.18.528.2.774l.006.084 2.267-.949.014-.006.073-.032a17.988 17.988 0 0 1 1.124-.448c.646-.232 1.561-.515 2.285-.515a6.7 6.7 0 0 1 1.58.189l2.782.677c1.178.286 2.03 1.326 2.03 2.545v.358c0 .051-.002.102-.005.153l2.261-1.65a2.712 2.712 0 0 1 3.477.243 2.587 2.587 0 0 1 0 3.724m0 0-2.517 2.45a5.74 5.74 0 0 1-2.904 1.512l-3.558.692c-.823.16-1.672.14-2.488-.058l-3.217-.782h-.002a4.102 4.102 0 0 0-.978-.118H6.831a5.86 5.86 0 0 1-.016.366c-.02.246-.066.512-.2.774a2 2 0 0 1-.874.874c-.262.133-.527.18-.774.2-.228.018-.503.018-.804.018H3.17c-.3 0-.575 0-.804-.019a2.029 2.029 0 0 1-.774-.2 2 2 0 0 1-.874-.873 2.028 2.028 0 0 1-.2-.774C.5 23.621.5 23.347.5 23.045V16.22c0-.3 0-.575.019-.804.02-.246.066-.512.199-.774a2 2 0 0 1 .874-.874c.262-.133.528-.179.774-.2.229-.018.503-.018.804-.018m3.663 8.268h2.212c.463 0 .924.056 1.375.166l3.216.782a4.157 4.157 0 0 0 1.776.041l3.557-.692a4.072 4.072 0 0 0 2.06-1.072l2.518-2.448a.921.921 0 0 0 0-1.336 1.045 1.045 0 0 0-1.332-.09l-2.933 2.14a3.303 3.303 0 0 1-1.95.633H14.5a.833.833 0 0 1 0-1.667h1.803c.578 0 1.006-.45 1.006-.956v-.358a.965.965 0 0 0-.756-.925l-2.783-.677a5.04 5.04 0 0 0-1.186-.142c-.402 0-1.07.183-1.723.417a16.267 16.267 0 0 0-1.015.404l-.06.027-.015.007-.004.001s-2.587 1.45-2.934.692m-1.666 0v6.252c0 .34-.001.546-.013.698a.682.682 0 0 1-.024.154.334.334 0 0 1-.144.144.69.69 0 0 1-.154.024 9.807 9.807 0 0 1-.699.013H3.2c-.34 0-.546 0-.698-.013a.69.69 0 0 1-.154-.024.334.334 0 0 1-.144-.144.68.68 0 0 1-.024-.154 9.755 9.755 0 0 1-.013-.698v-6.767c0-.34 0-.545.013-.698a.68.68 0 0 1 .024-.154.333.333 0 0 1 .144-.144.677.677 0 0 1 .154-.024c.152-.012.358-.013.698-.013h.933c.34 0 .546 0 .699.013.105.009.145.02.154.024a.333.333 0 0 1 .144.144.68.68 0 0 1 .024.154c.012.152.013.358.013.698v.515Zm-.038-1.369v.002Zm-2.783-.141.002-.001Zm-.142 8.616v-.002Zm2.784.142h-.002ZM7.5 5.632a4.917 4.917 0 0 1 8.6-3.256 4.917 4.917 0 1 1-1.534 7.68A4.917 4.917 0 0 1 7.5 5.632Zm6.184 2.994a4.902 4.902 0 0 1-.35-1.827 4.9 4.9 0 0 1 1.404-3.441 3.25 3.25 0 1 0-1.054 5.268ZM18.25 3.55a3.25 3.25 0 1 0 0 6.5 3.25 3.25 0 0 0 0-6.5Z',
      },
    ],
  },
  coinsStack: {
    viewbox: '0 0 25 23',
    paths: [
      {
        fillRule: 'evenodd',
        clipRule: 'evenodd',
        d: 'M1.667 3.168v-.001h11.166a.147.147 0 0 1-.023.061.858.858 0 0 1-.19.215c-.222.19-.59.399-1.117.59-1.049.382-2.552.634-4.253.634-1.7 0-3.204-.252-4.252-.634-.528-.191-.896-.4-1.117-.59a.856.856 0 0 1-.191-.215.148.148 0 0 1-.023-.06Zm0-.001h11.166s.002-.018-.023-.062a.858.858 0 0 0-.19-.215c-.222-.19-.59-.398-1.117-.59-1.049-.381-2.552-.633-4.253-.633-1.7 0-3.204.252-4.252.633-.528.192-.896.4-1.117.59a.856.856 0 0 0-.191.215c-.024.043-.023.062-.023.062ZM12.072 5.6c.267-.097.523-.206.761-.326v2.495a6.07 6.07 0 0 0-1.094.531 4.031 4.031 0 0 0-.445.327c-.078.067-.154.139-.226.216-1.015.301-2.345.49-3.818.49-1.7 0-3.204-.252-4.252-.633-.528-.192-.896-.4-1.117-.59a.856.856 0 0 1-.191-.215.148.148 0 0 1-.023-.06V5.274c.238.12.494.229.761.326 1.274.463 2.979.733 4.822.733s3.548-.27 4.822-.733ZM10.5 10.697c-.977.195-2.085.303-3.25.303-1.843 0-3.548-.27-4.822-.734a7.025 7.025 0 0 1-.761-.325v2.56c0 .005.002.023.023.06a.857.857 0 0 0 .19.215c.222.19.59.399 1.118.59 1.048.382 2.551.634 4.252.634 1.212 0 2.328-.128 3.25-.341v-2.962Zm0 4.666c-.977.196-2.085.304-3.25.304-1.843 0-3.548-.27-4.822-.734a7.023 7.023 0 0 1-.761-.326v2.56s-.002.017.023.061a.855.855 0 0 0 .19.215c.222.19.59.399 1.118.59 1.048.382 2.551.634 4.252.634 1.212 0 2.328-.129 3.25-.342v-2.962Zm.078 4.651c-.996.206-2.131.32-3.328.32-1.843 0-3.548-.27-4.822-.734-.634-.23-1.205-.525-1.634-.893C.368 18.34 0 17.823 0 17.167v-14c0-.657.368-1.174.794-1.54.429-.369 1-.663 1.634-.893C3.702.27 5.407 0 7.25 0s3.548.27 4.822.734c.634.23 1.205.524 1.634.893.426.366.794.883.794 1.54v4.136A16.77 16.77 0 0 1 17.75 7c1.843 0 3.548.27 4.822.734.634.23 1.205.524 1.634.893.426.366.794.883.794 1.54V19.5c0 .656-.368 1.174-.794 1.54-.429.369-1 .663-1.634.893-1.274.463-2.979.734-4.822.734s-3.548-.27-4.822-.734c-.634-.23-1.205-.524-1.634-.893-.307-.264-.585-.608-.716-1.026Zm3.331-10.85c1.014-.304 2.352-.497 3.841-.497 1.7 0 3.204.252 4.253.633.527.192.895.4 1.116.59a.858.858 0 0 1 .191.215c.025.044.023.062.023.062H12.167v-.005m1.332-.863c.127-.046.263-.09.407-.134Zm-1.332.899a.808.808 0 0 1 .036.052c.066.103.226.263.542.444.308.176.719.346 1.224.493 1.01.295 2.326.48 3.781.48 1.7 0 3.204-.252 4.253-.634.527-.191.895-.4 1.116-.59a.856.856 0 0 0 .191-.215.147.147 0 0 0 .023-.06l-11.166-.001v.03Zm0 2.076v2.65a.838.838 0 0 1 .133.11c.283.289.92.628 1.925.89.973.254 2.192.41 3.525.41 1.7 0 3.204-.253 4.252-.634.528-.192.896-.4 1.117-.59a.855.855 0 0 0 .191-.215c.025-.044.023-.062.023-.062v-2.559a7.02 7.02 0 0 1-.76.326c-1.275.463-2.98.733-4.823.733-1.584 0-3.06-.2-4.248-.546a7.905 7.905 0 0 1-1.335-.513Zm0 4.667V19.5s-.002.018.023.062a.858.858 0 0 0 .19.214c.222.19.59.399 1.117.59 1.049.382 2.552.634 4.253.634 1.7 0 3.204-.252 4.253-.633.527-.192.895-.4 1.116-.59a.858.858 0 0 0 .191-.215c.025-.044.023-.062.023-.062v-2.56c-.238.121-.494.23-.761.326-1.274.464-2.98.734-4.822.734-1.454 0-2.816-.168-3.946-.463a8.35 8.35 0 0 1-1.637-.596Z',
      },
    ],
  },
  coinsSwap: {
    viewbox: '0 0 26 26',
    paths: [
      {
        fillRule: 'evenodd',
        clipRule: 'evenodd',
        d: 'M5.077.41a.833.833 0 0 1 1.179 0l2.333 2.334a.833.833 0 0 1 0 1.179L6.256 6.256a.833.833 0 1 1-1.179-1.179l.911-.91h-.321A3.833 3.833 0 0 0 1.833 8 .833.833 0 1 1 .167 8a5.5 5.5 0 0 1 5.5-5.5h.321l-.91-.91a.833.833 0 0 1 0-1.18ZM9.5 8a7.833 7.833 0 1 1 6.153 7.652A7.833 7.833 0 1 1 9.68 9.68 7.859 7.859 0 0 1 9.5 8Zm2.152 2.401a7.868 7.868 0 0 1 3.28 3.28 6.167 6.167 0 1 0-3.28-3.28ZM8 11.167A6.167 6.167 0 1 0 8 23.5a6.167 6.167 0 0 0 0-12.333ZM24.333 16.5c.46 0 .834.373.834.833a5.5 5.5 0 0 1-5.5 5.5h-.322l.91.911a.833.833 0 1 1-1.178 1.178l-2.333-2.333a.833.833 0 0 1 0-1.178l2.333-2.334a.833.833 0 1 1 1.179 1.179l-.91.91h.32a3.833 3.833 0 0 0 3.834-3.833c0-.46.373-.833.833-.833Z',
      },
    ],
  },
  coins: {
    viewbox: '0 0 20 20',
    paths: [
      {
        d: 'M7.8 5.3C4 5.3.9 8.4.9 12.2s3.1 6.9 6.9 6.9 6.9-3.1 6.9-6.9-3.1-6.9-6.9-6.9zm0 12.3c-3 0-5.4-2.4-5.4-5.4s2.4-5.4 5.4-5.4 5.4 2.4 5.4 5.4-2.4 5.4-5.4 5.4zm11.3-9.8c0 1.8-.7 3.6-2 4.9-.1.1-.3.2-.5.2s-.4-.1-.5-.2c-.3-.3-.3-.8 0-1.1 1-1 1.6-2.4 1.6-3.8C17.6 6.4 17 5 16 4s-2.4-1.6-3.8-1.6S9.4 3 8.4 4c-.3.3-.8.3-1.1 0-.3-.3-.3-.8 0-1.1 1.3-1.3 3-2 4.9-2 1.8 0 3.6.7 4.9 2 1.3 1.3 2 3.1 2 4.9z',
      },
    ],
  },
  coment: {
    viewbox: '0 0 20 20',
    paths: [
      {
        d: 'M19.1.9C18.6.3 17.8 0 17 0H3C2.2 0 1.4.3.9.9.3 1.4 0 2.2 0 3v16c0 .4.2.8.6.9.4.2.8.1 1.1-.2L5.4 16H17c.8 0 1.6-.3 2.1-.9.6-.6.9-1.3.9-2.1V3c0-.8-.3-1.6-.9-2.1zM18 13c0 .3-.1.5-.3.7-.2.2-.4.3-.7.3H5c-.3 0-.5.1-.7.3L2 16.6V3c0-.3.1-.5.3-.7.2-.2.4-.3.7-.3h14c.3 0 .5.1.7.3.2.2.3.4.3.7v10z',
      },
    ],
  },
  content: {
    viewbox: '0 0 26 26',
    paths: [
      {
        fillRule: 'evenodd',
        clipRule: 'evenodd',
        d: 'M13 2.382c-5.983 0-10.833 4.85-10.833 10.834 0 5.983 4.85 10.833 10.833 10.833 5.983 0 10.833-4.85 10.833-10.833 0-5.983-4.85-10.834-10.833-10.834ZM.5 13.216C.5 6.312 6.096.716 13 .716s12.5 5.596 12.5 12.5c0 6.903-5.596 12.5-12.5 12.5S.5 20.119.5 13.216ZM11.193 9.35c.357.29.41.815.12 1.172-.599.735-1.456 1.194-2.396 1.194-.95 0-1.781-.466-2.387-1.182a.833.833 0 1 1 1.273-1.076c.351.415.744.591 1.114.591.377 0 .78-.183 1.104-.58a.833.833 0 0 1 1.172-.12Zm8.167 0c.356.29.41.815.12 1.172-.599.735-1.456 1.194-2.397 1.194-.949 0-1.78-.466-2.386-1.182a.833.833 0 0 1 1.273-1.076c.351.415.744.591 1.113.591.378 0 .781-.183 1.104-.58a.833.833 0 0 1 1.173-.12ZM8.999 15.048l.008.01.046.056a6.107 6.107 0 0 0 1.01.928c.71.516 1.708 1.007 2.937 1.007 1.229 0 2.227-.49 2.937-1.007a6.101 6.101 0 0 0 1.01-.928 2.53 2.53 0 0 0 .046-.056l.008-.01a.833.833 0 0 1 1.332 1.001l-.666-.5.666.5v.001l-.002.002-.002.003-.007.01-.022.028a6.244 6.244 0 0 1-.35.398 7.768 7.768 0 0 1-1.033.899c-.894.65-2.23 1.326-3.917 1.326-1.688 0-3.023-.676-3.917-1.326a7.772 7.772 0 0 1-1.032-.9 6.247 6.247 0 0 1-.35-.397l-.023-.029-.007-.009-.002-.003-.001-.002.665-.5-.666.5a.833.833 0 0 1 1.332-1.002Zm8.003-.001c0-.001 0 0 0 0Z',
      },
    ],
  },
  copy: {
    viewbox: '0 0 20 20',
    paths: [
      {
        d: 'M16.7 19.1H9.2c-1.3 0-2.4-1.1-2.4-2.4V9.2c0-1.3 1.1-2.4 2.4-2.4h7.5c1.3 0 2.4 1.1 2.4 2.4v7.5c0 1.3-1.1 2.4-2.4 2.4zM9.2 8.2c-.5 0-.9.4-.9.9v7.5c0 .5.4.9.9.9h7.5c.5 0 .9-.4.9-.9V9.2c0-.5-.4-.9-.9-.9H9.2zm-5 5h-.9c-.6 0-1.3-.3-1.7-.7-.5-.5-.7-1.1-.7-1.7V3.3c0-.6.3-1.3.7-1.7S2.7.9 3.3.9h7.5c.6 0 1.3.3 1.7.7.5.5.7 1.1.7 1.7v.8c0 .4-.3.8-.8.8s-.8-.3-.8-.8v-.8c0-.2-.1-.5-.3-.6s-.4-.3-.6-.3H3.3c-.2 0-.5.1-.6.3s-.3.4-.3.6v7.5c0 .2.1.5.3.6s.4.3.6.3h.8c.4 0 .8.3.8.8s-.3.7-.7.7z',
      },
    ],
  },
  creditCard: {
    viewbox: '0 0 24 24',
    paths: [
      {
        d: 'M21 21H3c-1.7 0-3-1.3-3-3V6c0-1.7 1.3-3 3-3h18c1.7 0 3 1.3 3 3v12c0 1.7-1.3 3-3 3zM2 11v7c0 .6.4 1 1 1h18c.6 0 1-.4 1-1v-7H2zm0-2h20V6c0-.6-.4-1-1-1H3c-.6 0-1 .4-1 1v3z',
      },
    ],
  },
  discord: {
    viewbox: '0 0 34 34',
    paths: [
      {
        fillRule: 'evenodd',
        clipRule: 'evenodd',
        d: 'M17 34c9.4 0 17-7.6 17-17S26.4 0 17 0 0 7.6 0 17s7.6 17 17 17zm2.6-25c1.4.2 2.8.7 4.1 1.3 2.2 3.3 3.3 7 2.9 11.2-1.7 1.3-3.4 2-5 2.5-.4-.5-.8-1.1-1.1-1.7.6-.2 1.2-.5 1.7-.8-.1-.1-.3-.2-.4-.3-3.2 1.5-6.7 1.5-10 0-.1.1-.3.2-.4.3.5.3 1.1.6 1.7.8-.3.6-.7 1.2-1.1 1.7-1.6-.5-3.3-1.3-5-2.5-.3-3.7.3-7.4 2.9-11.2 1.3-.6 2.6-1 4.1-1.3.2.3.4.7.5 1.1 1.5-.2 3-.2 4.5 0 .2-.4.4-.8.6-1.1zm-7.8 8.2c0 1.1.8 2 1.8 2s1.8-.9 1.8-2-.8-2-1.8-2-1.8 1-1.8 2zm6.5 0c0 1.1.8 2 1.8 2s1.8-.9 1.8-2-.8-2-1.8-2-1.8 1-1.8 2z',
      },
    ],
  },
  edit: {
    viewbox: '0 0 20 20',
    paths: [
      {
        d: 'M16 2.1c-.3 0-.6.1-.8.3L2.9 15.3l-.5 2.2 2.1-.5L16.8 4.1c.1-.1.2-.2.2-.4.1-.1.1-.3.1-.4 0-.2 0-.3-.1-.4-.1-.1-.1-.3-.2-.4-.1-.1-.2-.2-.4-.3-.1-.1-.3-.1-.4-.1zM13.8 1c.6-.6 1.4-1 2.2-1 .4 0 .8.1 1.2.2.4.2.7.4 1 .7.3.3.5.7.7 1.1s.2.8.2 1.2-.1.9-.2 1.3c-.2.4-.4.8-.7 1.1l-12.5 13c-.1.1-.3.2-.5.3l-4 1c-.3.1-.7 0-1-.3-.2-.3-.3-.6-.3-1l1-4.2c0-.2.1-.4.3-.5L13.8 1zM9 19c0-.6.4-1 1-1h9c.6 0 1 .5 1 1 0 .6-.4 1-1 1h-9c-.6 0-1-.5-1-1z',
      },
    ],
  },
  ellipsis: {
    viewbox: '0 0 20 20',
    paths: [
      {
        d: 'M12.2 10c0 1.2-1 2.2-2.2 2.2s-2.2-1-2.2-2.2 1-2.2 2.2-2.2 2.2 1 2.2 2.2zm5.6-2.2c-1.2 0-2.2 1-2.2 2.2s1 2.2 2.2 2.2 2.2-1 2.2-2.2-1-2.2-2.2-2.2zm-15.6 0C1 7.8 0 8.8 0 10s1 2.2 2.2 2.2 2.2-1 2.2-2.2-.9-2.2-2.2-2.2z',
      },
    ],
  },
  eye: {
    viewbox: '0 0 20 20',
    paths: [
      {
        d: 'M10 17.4c-6.2 0-9.7-6.8-9.8-7.1-.1-.2-.1-.5 0-.7.1-.2 3.6-7 9.8-7 6.2 0 9.7 6.8 9.8 7.1.1.2.1.5 0 .7-.1.2-3.6 7-9.8 7zM1.7 10c.8 1.3 3.7 5.9 8.3 5.9 4.6 0 7.6-4.6 8.3-5.9-.8-1.3-3.7-5.9-8.3-5.9-4.6 0-7.6 4.6-8.3 5.9zm8.3 3.2c-1.8 0-3.2-1.5-3.2-3.2S8.2 6.7 10 6.7s3.2 1.5 3.2 3.3-1.4 3.2-3.2 3.2zm0-5c-1 0-1.8.8-1.8 1.8s.8 1.7 1.8 1.7 1.8-.8 1.8-1.8S11 8.2 10 8.2z',
      },
    ],
  },
  facebook: {
    viewbox: '0 0 32 32',
    paths: [
      {
        d: 'M32 16c0-8.8-7.2-16-16-16S0 7.2 0 16s7.2 16 16 16h.3V19.5h-3.4v-4h3.4v-2.9c0-3.4 2.1-5.3 5.1-5.3 1.5 0 2.7.1 3.1.2V11h-2.1c-1.7 0-2 .8-2 1.9v2.6h4l-.5 4h-3.5v11.8C27.1 29.5 32 23.3 32 16z',
      },
    ],
  },
  filter: {
    viewbox: '0 0 20 20',
    paths: [
      {
        d: 'M0 4c0-.6.4-1 1-1h18c.6 0 1 .4 1 1s-.4 1-1 1H1c-.6 0-1-.4-1-1zm3 6c0-.6.4-1 1-1h12c.6 0 1 .4 1 1s-.4 1-1 1H4c-.6 0-1-.4-1-1zm3 6c0-.6.4-1 1-1h6c.6 0 1 .4 1 1s-.4 1-1 1H7c-.6 0-1-.4-1-1z',
      },
    ],
  },
  flag: {
    viewbox: '0 0 20 20',
    paths: [
      {
        d: 'M3.3 19.1c-.4 0-.8-.3-.8-.8V2.5c0-.2.1-.4.2-.5C2.8 1.9 3.8.9 6.6.9c1.4 0 2.5.5 3.6.9 1 .4 1.9.8 3.1.8 2.1 0 2.8-.6 2.8-.6.2-.2.5-.3.8-.1.3.1.5.4.5.7v10c0 .2-.1.4-.2.5-.1.1-1.1 1.1-3.9 1.1-1.4 0-2.5-.5-3.6-.9-1-.4-1.9-.8-3.1-.8-1.4 0-2.2.3-2.6.5v5.4c.1.3-.3.7-.7.7zm3.4-8.2c1.4 0 2.5.5 3.6.9 1 .4 1.9.8 3.1.8 1.4 0 2.2-.3 2.6-.5V3.7c-.6.2-1.4.4-2.6.4-1.4 0-2.5-.5-3.6-.9-1-.4-1.9-.8-3.1-.8-1.4 0-2.2.3-2.6.5v8.4c.6-.2 1.4-.4 2.6-.4z',
      },
    ],
  },
  flash: {
    viewbox: '0 0 20 22',
    paths: [
      {
        d: 'M9 22c-.1 0-.3 0-.4-.1-.4-.2-.6-.6-.6-1l.9-6.9H1c-.4 0-.7-.2-.9-.6-.2-.4-.1-.8.1-1.1l10-12c.3-.3.8-.4 1.2-.2.4.2.6.6.6 1L11.1 8H19c.4 0 .7.2.9.6.2.4.1.8-.1 1.1l-10 12c-.2.2-.5.3-.8.3zM3.1 12H10c.3 0 .6.1.7.3.2.2.3.5.2.8l-.6 4.6 6.4-7.7H10c-.3 0-.6-.1-.7-.3-.2-.3-.3-.5-.3-.8l.6-4.6L3.1 12z',
      },
    ],
  },
  forbidden: {
    viewbox: '0 0 20 20',
    paths: [
      {
        d: 'M3.7 4.6c-1.2 1.5-2 3.4-2 5.4 0 4.7 3.8 8.5 8.5 8.5 2.1 0 3.9-.7 5.4-2L3.7 4.6zm1.1-1.1 11.9 11.9c1.2-1.5 2-3.4 2-5.4 0-4.7-3.8-8.5-8.5-8.5-2 0-3.9.8-5.4 2zM.2 10c0-5.5 4.5-10 10-10s10 4.5 10 10-4.5 10-10 10-10-4.5-10-10z',
      },
    ],
  },
  github: {
    viewbox: '0 0 32 32',
    paths: [
      {
        d: 'M16 0C7.2 0 0 7.3 0 16.4 0 23.7 4.6 29.8 10.9 32c.8.2 1.1-.4 1.1-.8v-2.8c-4.5 1-5.4-2.2-5.4-2.2-.7-1.9-1.8-2.4-1.8-2.4-1.4-1 .1-1 .1-1 1.6.1 2.5 1.7 2.5 1.7 1.4 2.5 3.7 1.8 4.7 1.4.1-1.1.6-1.8 1-2.2-3.6-.4-7.3-1.8-7.3-8.1 0-1.8.6-3.3 1.6-4.4-.2-.4-.7-2.1.1-4.3 0 0 1.3-.4 4.4 1.7 1.3-.4 2.6-.5 4-.6 1.4 0 2.7.2 4 .6 3-2.1 4.4-1.7 4.4-1.7.9 2.3.3 3.9.2 4.3 1 1.1 1.6 2.6 1.6 4.4 0 6.3-3.7 7.7-7.3 8.1.6.5 1.1 1.5 1.1 3v4.5c0 .4.3.9 1.1.8 6.4-2.2 11-8.3 11-15.5C32 7.3 24.8 0 16 0z',
      },
    ],
  },
  grid: {
    viewbox: '0 0 24 24',
    paths: [
      {
        d: 'M10 11H3c-.6 0-1-.4-1-1V3c0-.6.4-1 1-1h7c.6 0 1 .4 1 1v7c0 .6-.4 1-1 1zM4 9h5V4H4v5zm17 2h-7c-.6 0-1-.4-1-1V3c0-.6.4-1 1-1h7c.6 0 1 .4 1 1v7c0 .6-.4 1-1 1zm-6-2h5V4h-5v5zm6 13h-7c-.6 0-1-.4-1-1v-7c0-.6.4-1 1-1h7c.6 0 1 .4 1 1v7c0 .6-.4 1-1 1zm-6-2h5v-5h-5v5zm-5 2H3c-.6 0-1-.4-1-1v-7c0-.6.4-1 1-1h7c.6 0 1 .4 1 1v7c0 .6-.4 1-1 1zm-6-2h5v-5H4v5z',
      },
    ],
  },
  growth: {
    viewbox: '0 0 20 20',
    paths: [
      {
        d: 'M14.2 5.8c-.5 0-.8-.4-.8-.8s.4-.8.8-.8h5c.4 0 .8.3.8.8v5c0 .5-.4.8-.8.8s-.8-.4-.8-.8V7l-6.5 6.5c-.3.3-.9.3-1.2 0L7.1 9.9l-5.7 5.7c-.3.3-.9.3-1.2 0-.3-.3-.3-.9 0-1.2l6.2-6.3c.3-.3.9-.3 1.2 0l3.6 3.6 5.9-5.9h-2.9z',
      },
    ],
  },
  heartFilled: {
    viewbox: '0 0 20 20',
    paths: [
      {
        d: 'M19.5 7c0 .7-.1 1.4-.4 2-.3.7-.7 1.2-1.2 1.7l-7.4 7.4c-.1.3-.3.3-.5.3s-.4-.1-.5-.2l-7.4-7.4C1.1 9.8.5 8.5.5 7c0-1.4.6-2.8 1.6-3.8s2.3-1.6 3.8-1.6 2.8.6 3.8 1.6l.3.5.4-.4c.5-.5 1.1-.9 1.7-1.2 1.3-.5 2.8-.5 4.1 0 .7.3 1.2.7 1.7 1.2s.9 1.1 1.2 1.7c.3.7.4 1.3.4 2z',
      },
    ],
  },
  heart: {
    viewbox: '0 0 20 20',
    paths: [
      {
        d: 'M10 18.4c-.2 0-.4-.1-.5-.2l-7.4-7.4C1.1 9.8.5 8.5.5 7c0-1.4.6-2.8 1.6-3.8s2.3-1.6 3.8-1.6 2.8.6 3.8 1.6l.3.5.4-.4c.5-.5 1.1-.9 1.7-1.2 1.3-.5 2.8-.5 4.1 0 .7.3 1.2.7 1.7 1.2s.9 1.1 1.2 1.7c.3.7.4 1.3.4 2s-.1 1.4-.4 2c-.3.7-.7 1.2-1.2 1.7l-7.4 7.4c-.1.3-.3.3-.5.3zM5.9 3.2c-1 0-2 .4-2.7 1.1C2.4 5.1 2 6.1 2 7.1s.4 2 1.1 2.7l6.8 6.8 6.8-6.8c.4-.4.6-.8.8-1.2.2-.5.3-1 .3-1.5s-.1-1-.3-1.5c-.2-.5-.5-.9-.8-1.2-.4-.4-.8-.6-1.2-.8-.9-.4-2-.4-2.9 0-.5.2-.9.5-1.2.8l-.9.9c-.3.3-.8.3-1.1 0l-.8-.9c-.7-.8-1.7-1.2-2.7-1.2z',
      },
    ],
  },
  help: {
    viewbox: '0 0 22 22',
    paths: [
      {
        d: 'M11 22c-3 0-5.7-1.2-7.7-3.2l-.1-.1-.1-.1C1.2 16.7 0 14 0 11s1.2-5.7 3.2-7.7l.1-.1.1-.1C5.3 1.2 8 0 11 0s5.7 1.2 7.7 3.2l.1.1.1.1c2 2 3.2 4.7 3.2 7.7s-1.2 5.7-3.2 7.7l-.1.1-.1.1c-2 1.8-4.7 3-7.7 3zm-5.6-4c1.5 1.2 3.5 2 5.6 2 2.1 0 4.1-.7 5.6-2l-2.9-2.9c-.7.6-1.7.9-2.7.9s-2-.3-2.8-.8L5.4 18zM4 5.4C2.7 6.9 2 8.9 2 11c0 2.1.7 4.1 2 5.6l2.9-2.9C6.3 13 6 12 6 11s.3-2 .8-2.8L4 5.4zm11.2 8.4 2.9 2.9c1.2-1.5 2-3.5 2-5.6 0-2.1-.7-4.1-2-5.6l-2.9 2.9c.5.6.8 1.6.8 2.6s-.3 2-.8 2.8zM11 8c-1.7 0-3 1.3-3 3s1.3 3 3 3 3-1.3 3-3-1.3-3-3-3zm0-2c1 0 2 .3 2.8.8L16.6 4c-1.5-1.2-3.5-2-5.6-2-2.1 0-4.1.7-5.6 2l2.9 2.9C9 6.3 10 6 11 6z',
      },
    ],
  },
  home: {
    viewbox: '0 0 20 20',
    paths: [
      {
        d: 'M18.7 6.6 10.5.2c-.3-.3-.8-.3-1.1 0L1.3 6.6c-.3.1-.4.4-.4.7v10A2.732 2.732 0 0 0 3.6 20h12.8a2.732 2.732 0 0 0 2.7-2.7v-10c0-.3-.1-.6-.4-.7zm-6.9 11.6H8.2v-7.3h3.6v7.3zm5.5-.8c0 .2-.1.5-.3.6-.2.2-.4.3-.6.3h-2.8V10c0-.5-.4-.9-.9-.9H7.3c-.5 0-.9.4-.9.9v8.2H3.6c-.2 0-.5-.1-.6-.3-.2-.2-.3-.4-.3-.6V7.7L10 2.1l7.3 5.7v9.6z',
      },
    ],
  },
  image: {
    viewbox: '0 0 20 20',
    paths: [
      {
        d: 'M17 0H3C1.3 0 0 1.3 0 3v14c0 1.7 1.3 3 3 3h14c1.7 0 3-1.3 3-3V3c0-1.7-1.3-3-3-3zm1 17c0 .6-.4 1-1 1H5.4L14 9.4l4 4V17zm0-6.4-3.3-3.3c-.4-.4-1-.4-1.4 0L2.6 17.9c-.3-.1-.6-.5-.6-.9V3c0-.5.5-1 1-1h14c.6 0 1 .4 1 1v7.6zM9 6.5C9 7.9 7.9 9 6.5 9S4 7.9 4 6.5 5.1 4 6.5 4 9 5.1 9 6.5z',
      },
    ],
  },
  impactMarket: {
    viewbox: '0 0 24 24',
    paths: [
      {
        d: 'M24 11.2c0 6.6-5.4 12-12 12s-12-5.4-12-12c0-1.9.5-3.8 1.3-5.5.9-1.7 2.1-3.1 3.6-4.2 1.7-1.2 4-.8 5.2.8 1.2 1.7.8 4-.8 5.2-.1 0-.1.1-.2.2-1 .8-1.6 1.9-1.7 3.1V11.1c0 2.5 2 4.5 4.5 4.5.7 0 1.4-.2 2-.4 1.5-.7 2.6-2.3 2.6-4.1 0-1.4-.6-2.6-1.7-3.5l-.2-.2-.3-.3c-.2-.3-.3-.6-.4-1 .1-.5.3-1.1.7-1.6.4-.5.9-.8 1.5-.8.6-.1 1.2.1 1.6.5 2.1 1.7 3.3 4.3 3.3 7 0 5-4.1 9-9 9s-9-4.1-9-9c0-2.7 1.2-5.3 3.3-7 .3-.3.7-.2 1 .1.3.3.2.8-.1 1-1.8 1.5-2.8 3.6-2.8 5.9 0 4.2 3.4 7.6 7.6 7.6s7.6-3.4 7.6-7.6c0-2.3-1-4.4-2.8-5.9-.2-.1-.4-.2-.6-.2-.2 0-.4.1-.6.3-.1.2-.2.4-.2.6 0 .2.1.4.3.6 0 0 .1 0 .1.1 1.2 1.1 1.9 2.5 2 4.1v.4c0 2.3-1.3 4.3-3.3 5.3-.8.4-1.7.7-2.7.7-3.3 0-6-2.7-6-6 0-1.7.7-3.4 2-4.5l.1-.1c.1-.1.2-.1.3-.2 1-.7 1.3-2.2.5-3.2-.7-1-2.2-1.3-3.2-.5-1.3 1-2.4 2.2-3.2 3.7-.8 1.5-1.2 3.2-1.2 4.9C1.4 17 6.2 21.8 12 21.8c5.8 0 10.6-4.7 10.6-10.6 0-1.7-.4-3.4-1.2-4.9-.7-1.4-1.8-2.7-3.2-3.7-1-.7-2.5-.5-3.2.5-.2.3-.7.4-1 .2s-.4-.7-.2-1C15 .6 17.4.3 19 1.5c1.5 1.1 2.7 2.5 3.6 4.2.9 1.7 1.4 3.6 1.4 5.5z',
      },
    ],
  },
  infoCircle: {
    viewbox: '0 0 20 20',
    paths: [
      {
        d: 'M10 0c5.5 0 10 4.5 10 10s-4.5 10-10 10S0 15.5 0 10 4.5 0 10 0zm0 18.2c4.5 0 8.2-3.7 8.2-8.2S14.5 1.8 10 1.8 1.8 5.5 1.8 10s3.7 8.2 8.2 8.2zm0-12.7c.5 0 .9.4.9.9s-.4.9-.9.9-.9-.4-.9-.9.4-.9.9-.9zm0 3.6c.5 0 .9.4.9.9v3.6c0 .5-.4.9-.9.9s-.9-.4-.9-.9V10c0-.5.4-.9.9-.9z',
      },
    ],
  },
  instagram: {
    viewbox: '0 0 34 34',
    paths: [
      {
        fillRule: 'evenodd',
        clipRule: 'evenodd',
        d: 'M17 34c9.4 0 17-7.6 17-17S26.4 0 17 0 0 7.6 0 17s7.6 17 17 17zM13.2 7.8c1 0 1.3-.1 3.8-.1s2.8 0 3.8.1c1 0 1.7.2 2.3.4.6.2 1.1.6 1.6 1.1.5.5.8 1 1.1 1.6.2.6.4 1.3.4 2.3 0 1 .1 1.3.1 3.8s0 2.8-.1 3.8c0 1-.2 1.7-.4 2.3-.2.6-.6 1.1-1.1 1.6-.5.5-1 .8-1.6 1.1-.6.2-1.3.4-2.3.4-1 0-1.3.1-3.8.1s-2.8 0-3.8-.1c-1 0-1.7-.2-2.3-.4-.6-.2-1.1-.6-1.6-1.1-.5-.5-.8-1-1.1-1.6-.2-.6-.4-1.3-.4-2.3 0-1-.1-1.3-.1-3.8s0-2.8.1-3.8c0-1 .2-1.7.4-2.3.2-.6.6-1.1 1.1-1.6.5-.5 1-.8 1.6-1.1.6-.2 1.3-.4 2.3-.4zm3.5 1.6h-.5c-1.7 0-2.1 0-2.9.1-.9 0-1.4.2-1.7.3-.4.2-.7.4-1.1.7-.3.3-.5.6-.7 1.1-.1.3-.3.8-.3 1.7 0 1-.1 1.3-.1 3.7 0 2.5 0 2.8.1 3.7 0 .9.2 1.4.3 1.7.2.4.4.7.7 1.1.3.3.6.5 1.1.7.3.1.8.3 1.7.3 1 0 1.3.1 3.7.1 2.5 0 2.8 0 3.7-.1.9 0 1.4-.2 1.7-.3.4-.2.7-.4 1.1-.7.3-.3.5-.6.7-1.1.1-.3.3-.8.3-1.7 0-1 .1-1.3.1-3.7 0-2.5 0-2.8-.1-3.7 0-.9-.2-1.4-.3-1.7-.2-.4-.4-.7-.7-1.1-.3-.3-.6-.5-1.1-.7-.3-.1-.8-.3-1.7-.3-1 0-1.3-.1-3.7-.1h-.3zm4.6 1.7c.2-.1.4-.2.6-.2.6 0 1.1.5 1.1 1.1 0 .2-.1.4-.2.6-.1.2-.3.3-.5.4s-.4.1-.6.1c-.2 0-.4-.1-.6-.3-.2-.2-.3-.4-.3-.6 0-.2 0-.4.1-.6.1-.2.2-.4.4-.5zM12.2 17c0-2.6 2.1-4.8 4.8-4.8 2.6 0 4.8 2.1 4.8 4.8s-2.1 4.8-4.8 4.8-4.8-2.2-4.8-4.8zm7.9 0c0-1.7-1.4-3.1-3.1-3.1-1.7 0-3.1 1.4-3.1 3.1 0 1.7 1.4 3.1 3.1 3.1 1.7 0 3.1-1.4 3.1-3.1z',
      },
    ],
  },
  key: {
    viewbox: '0 0 22 22',
    paths: [
      {
        d: 'M6.5 21.5c-.9 0-1.7-.2-2.5-.5s-1.5-.8-2.1-1.4C.7 18.4.1 16.7.1 15c0-1.7.7-3.3 1.9-4.5s2.8-1.9 4.5-1.9c1.4 0 2.7.4 3.8 1.2l9-9c.4-.4 1-.4 1.4 0 .2.2.3.4.3.7s-.1.5-.3.7l-1.3 1.3 2.3 2.3c.4.4.4 1 0 1.4l-3.5 3.5c-.4.4-1 .4-1.4 0l-2.3-2.3-2.7 2.7c.3.4.6.9.8 1.3.3.8.5 1.6.5 2.5 0 .9-.2 1.7-.5 2.5s-.8 1.5-1.4 2.1c-.7.7-1.4 1.2-2.2 1.5-.8.3-1.6.5-2.5.5zm.1-10.9s-.1 0 0 0c-1.2 0-2.3.5-3.2 1.3-.8.8-1.3 2-1.3 3.1 0 1.2.4 2.3 1.3 3.2.4.4.9.7 1.5 1 .5.2 1.1.3 1.7.4.6 0 1.2-.1 1.7-.3s1-.6 1.5-1c.4-.4.8-.9 1-1.5.2-.6.3-1.1.3-1.7 0-.6-.1-1.2-.4-1.7-.2-.5-.6-1-1-1.5-.9-.9-2-1.3-3.1-1.3zM15.9 7l1.6 1.6 2.1-2.1L18 4.9 15.9 7z',
      },
    ],
  },
  lineCircle: {
    viewbox: '0 0 24 10',
    paths: [
      {
        fillRule: 'evenodd',
        clipRule: 'evenodd',
        d: 'M11.95 2a3 3 0 1 0 0 6 3 3 0 0 0 0-6ZM7.049 4.005a5.002 5.002 0 0 1 9.802 0c.036-.003.072-.005.109-.005h5.95a1 1 0 1 1 0 2h-5.95c-.037 0-.073-.002-.109-.006a5.002 5.002 0 0 1-9.802.001A1.013 1.013 0 0 1 6.95 6H1a1 1 0 0 1 0-2h5.95c.033 0 .066.002.099.005Z',
      },
    ],
  },
  linkedin: {
    viewbox: '0 0 32 32',
    paths: [
      {
        d: 'M16 0C7.2 0 0 7.2 0 16s7.2 16 16 16 16-7.2 16-16S24.8 0 16 0zm-4.6 24.2H7.5V12.5h3.9v11.7zm-2-13.3c-1.3 0-2.2-.9-2.2-2 0-1.2.9-2 2.2-2 1.3 0 2.2.9 2.2 2s-.8 2-2.2 2zm16 13.3h-3.9v-6.3c0-1.6-.6-2.7-2-2.7-1.1 0-1.7.7-2 1.4-.1.3-.1.6-.1 1v6.5h-3.9s.1-10.6 0-11.7h3.9v1.7c.5-.8 1.4-1.9 3.5-1.9 2.6 0 4.5 1.7 4.5 5.3v6.7z',
      },
    ],
  },
  loader: {
    viewbox: '0 0 20 20',
    paths: [
      {
        d: 'M10 19.1c-.4 0-.8-.3-.8-.8V15c0-.4.3-.8.8-.8s.8.3.8.8v3.3c0 .4-.4.8-.8.8zm-5.9-2.5c-.2 0-.4-.1-.5-.2-.3-.3-.3-.8 0-1.1L5.9 13c.3-.3.8-.3 1.1 0s.3.8 0 1.1l-2.4 2.4c-.1.1-.3.1-.5.1zm11.8 0c-.2 0-.4-.1-.5-.2L13 14.1c-.3-.3-.3-.8 0-1.1s.8-.3 1.1 0l2.4 2.4c.3.3.3.8 0 1.1-.2.1-.4.1-.6.1zm2.4-5.9H15c-.4 0-.8-.3-.8-.8s.3-.8.8-.8h3.3c.4 0 .8.3.8.8s-.4.8-.8.8zM5 10.7H1.7c-.4 0-.8-.3-.8-.8s.3-.8.8-.8H5c.4 0 .8.3.8.8s-.4.8-.8.8zm8.5-3.5c-.2 0-.4-.1-.5-.2-.3-.3-.3-.8 0-1.1l2.4-2.4c.3-.3.8-.3 1.1 0s.3.8 0 1.1L14.1 7c-.2.1-.4.2-.6.2zm-7 0c-.2 0-.4-.1-.6-.2L3.6 4.6c-.3-.3-.3-.8 0-1.1s.8-.3 1.1 0L7 5.9c.3.3.3.8 0 1.1-.1.1-.3.2-.5.2zM10 5.7c-.4 0-.8-.3-.8-.7V1.7c0-.4.3-.8.8-.8s.8.3.8.8V5c0 .4-.4.7-.8.7z',
      },
    ],
  },
  lock: {
    viewbox: '0 0 20 20',
    paths: [
      {
        d: 'M16.2 8h-.7V5.5c0-1.5-.6-2.9-1.6-3.9S11.5 0 10 0 7.1.6 6.1 1.6 4.5 4 4.5 5.5V8h-.8C2.1 8 .8 9.3.8 10.9v6.2c0 1.6 1.3 2.9 2.9 2.9h12.5c1.6 0 2.9-1.3 2.9-2.9v-6.2c0-1.6-1.3-2.9-2.9-2.9zM6.6 5.5c0-.9.4-1.8 1-2.4.6-.6 1.5-1 2.4-1s1.8.4 2.4 1c.6.6 1 1.5 1 2.4V8H6.6V5.5zm10.3 11.6c0 .4-.3.7-.7.7H3.7c-.4 0-.7-.3-.7-.7v-6.2c0-.4.3-.7.7-.7h12.5c.4 0 .7.3.7.7v6.2z',
      },
    ],
  },
  logout: {
    viewbox: '0 0 20 20',
    paths: [
      {
        d: 'M8.2 17.5c0 .4-.3.8-.8.8H4.2c-.6 0-1.3-.3-1.7-.7-.5-.5-.7-1.1-.7-1.7V4.2c0-.6.3-1.3.7-1.7s1.1-.7 1.7-.7h3.3c.4 0 .8.3.8.8s-.4.6-.8.6H4.2c-.2 0-.5.1-.6.3s-.4.4-.4.7v11.7c0 .2.1.5.3.6s.4.3.6.3h3.3c.5-.1.8.3.8.7zm10-7.8c0-.1-.1-.2-.2-.2l-4.2-4.2c-.3-.3-.8-.3-1.1 0s-.3.8 0 1.1l2.9 2.9H7.5c-.4 0-.8.3-.8.8s.3.8.8.8h8.2l-2.9 2.9c-.3.3-.3.8 0 1.1.1.1.3.2.5.2s.4-.1.5-.2l4.2-4.2.2-.2c0-.1.1-.2.1-.3-.1-.3-.1-.4-.1-.5z',
      },
    ],
  },
  mail: {
    viewbox: '0 0 20 20',
    paths: [
      {
        d: 'M16.7 17.5H3.3C1.9 17.5.8 16.4.8 15V5c0-1.4 1.1-2.5 2.5-2.5h13.3c1.4 0 2.5 1.1 2.5 2.5v10c.1 1.4-1.1 2.5-2.4 2.5zM2.5 6.6V15c0 .5.4.8.8.8h13.3c.5 0 .8-.4.8-.8V6.6l-7 4.9c-.3.2-.7.2-1 0L2.5 6.6zm.1-2L10 9.8l7.4-5.2c-.1-.3-.4-.5-.7-.5H3.3c-.3.1-.6.3-.7.5z',
      },
    ],
  },
  medium: {
    viewbox: '0 0 34 34',
    paths: [
      {
        fillRule: 'evenodd',
        clipRule: 'evenodd',
        d: 'M17 34c9.4 0 17-7.6 17-17S26.4 0 17 0 0 7.6 0 17s7.6 17 17 17zm1.1-16.5c0 3.6-2.9 6.5-6.5 6.5s-6.5-2.9-6.5-6.5S8 11 11.6 11s6.5 2.9 6.5 6.5zm4.4 6c1.8 0 3.3-2.7 3.3-6s-1.5-6-3.3-6c-1.8 0-3.3 2.7-3.3 6 0 3.4 1.4 6 3.3 6zm6.5-6c0 3-.5 5.5-1.1 5.5-.6 0-1.1-2.4-1.1-5.5 0-3 .5-5.5 1.1-5.5.6.1 1.1 2.5 1.1 5.5z',
      },
    ],
  },
  menu: {
    viewbox: '0 0 24 24',
    paths: [
      {
        d: 'M21 19H3c-.6 0-1-.4-1-1s.4-1 1-1h18c.6 0 1 .4 1 1s-.4 1-1 1zm-4-6H3c-.6 0-1-.4-1-1s.4-1 1-1h14c.6 0 1 .4 1 1s-.4 1-1 1zm4-6H3c-.6 0-1-.4-1-1s.4-1 1-1h18c.6 0 1 .4 1 1s-.4 1-1 1z',
      },
    ],
  },
  minusCircle: {
    viewbox: '0 0 22 22',
    paths: [
      {
        d: 'M11 22C4.9 22 0 17.1 0 11S4.9 0 11 0s11 4.9 11 11-4.9 11-11 11zm0-20c-5 0-9 4-9 9s4 9 9 9 9-4 9-9-4-9-9-9zm4 10H7c-.6 0-1-.4-1-1s.4-1 1-1h8c.6 0 1 .4 1 1s-.4 1-1 1z',
      },
    ],
  },
  open: {
    viewbox: '0 0 20 20',
    paths: [
      {
        d: 'M11.9 1.1c0-.6.4-1.1 1.1-1.1h5.9c.6 0 1.1.5 1.1 1.1V7c0 .6-.5 1.1-1.1 1.1-.6 0-1.1-.5-1.1-1.1V3.8l-9 9c-.4.4-1.1.4-1.6 0-.4-.4-.4-1.1 0-1.6l9-9H13c-.7 0-1.1-.5-1.1-1.1zM3.1 5.2c-.2 0-.4.1-.6.3-.2.1-.3.3-.3.5v10.9c0 .2.1.4.3.6.2.2.4.3.6.3H14c.2 0 .4-.1.6-.3.2-.2.3-.4.3-.6V11c0-.6.5-1.1 1.1-1.1.6 0 1.1.5 1.1 1.1v5.9c0 .8-.3 1.6-.9 2.2-.6.6-1.4.9-2.2.9H3.1c-.8 0-1.6-.3-2.2-.9-.6-.6-.9-1.4-.9-2.2V6c0-.8.3-1.6.9-2.2.6-.5 1.4-.8 2.2-.8H9c.6 0 1.1.5 1.1 1.1S9.6 5.2 9 5.2H3.1z',
      },
    ],
  },
  percentage: {
    viewbox: '0 0 26 26',
    paths: [
      {
        fillRule: 'evenodd',
        clipRule: 'evenodd',
        d: 'M12.667 1.833c-5.983 0-10.834 4.85-10.834 10.834 0 5.983 4.85 10.833 10.834 10.833 5.983 0 10.833-4.85 10.833-10.833 0-5.983-4.85-10.834-10.833-10.834ZM.167 12.667c0-6.904 5.596-12.5 12.5-12.5 6.903 0 12.5 5.596 12.5 12.5 0 6.903-5.597 12.5-12.5 12.5-6.904 0-12.5-5.597-12.5-12.5ZM17.923 7.41a.833.833 0 0 1 0 1.178l-9.334 9.333a.833.833 0 1 1-1.178-1.178l9.333-9.333a.833.833 0 0 1 1.179 0ZM7.75 9.167a1.417 1.417 0 1 1 2.833 0 1.417 1.417 0 0 1-2.833 0Zm7 7a1.417 1.417 0 1 1 2.833 0 1.417 1.417 0 0 1-2.833 0Z',
      },
    ],
  },
  phone: {
    viewbox: '0 0 32 32',
    paths: [
      {
        d: 'M27.1 32h-.4c-4.6-.5-9.1-2.1-13-4.6-3.6-2.3-6.7-5.4-9-9C2.1 14.5.5 10 0 5.4c0-.8 0-1.4.3-2.1.2-.6.6-1.2 1-1.7.5-.5 1-.9 1.6-1.2.6-.3 1.3-.4 2-.4h4.2c1.2 0 2.3.4 3.2 1.2s1.5 1.8 1.7 3c.2 1.2.4 2.4.9 3.5.3.9.4 1.8.2 2.7-.2.9-.6 1.8-1.3 2.4l-.6.6c1.4 2.1 3.3 4 5.4 5.4l.6-.6c.7-.7 1.5-1.1 2.4-1.3.9-.2 1.9-.1 2.7.2 1.1.4 2.3.7 3.5.9 1.2.2 2.3.8 3.1 1.7.8.9 1.2 2.1 1.2 3.3v4.2c0 .7-.1 1.3-.4 2-.3.6-.7 1.2-1.2 1.6-.5.5-1.1.8-1.7 1-.6.1-1.2.2-1.7.2zM9.1 4.2H4.9c-.1 0-.2 0-.3.1-.1 0-.2.1-.2.2-.1 0-.1.1-.2.2V5c.4 3.9 1.8 7.8 4 11.2 2 3.1 4.7 5.8 7.8 7.7 3.4 2.2 7.2 3.5 11.2 4h.2c.1 0 .2-.1.2-.1l.2-.2c0-.1.1-.2.1-.3v-4.2c0-.2-.1-.3-.2-.5-.1-.1-.3-.2-.4-.2-1.5-.2-3-.6-4.4-1.1-.1-.1-.3-.1-.4 0-.1 0-.3.1-.4.2L20.3 23c-.7.7-1.7.8-2.5.3-3.8-2.2-7-5.3-9.2-9.2-.5-.8-.3-1.8.3-2.5l1.8-1.8c.1-.1.2-.2.2-.3v-.4c-.5-1.4-.9-2.8-1.1-4.3 0-.1-.1-.3-.2-.4-.2-.2-.3-.2-.5-.2z',
      },
    ],
  },
  piggy: {
    viewbox: '0 0 26 23',
    paths: [
      {
        fillRule: 'evenodd',
        clipRule: 'evenodd',
        d: 'M7.167 5.083a4.917 4.917 0 0 1 9.82-.351l2.454-.701c.179-.051.362-.103.52-.134.171-.033.412-.061.676.013.34.097.631.317.817.617.144.233.183.472.198.646.015.16.015.35.015.537V7.088l.06.061a7.849 7.849 0 0 1 1.554 2.234c.02.046.038.084.054.117H23.438c.137 0 .282 0 .408.01.142.01.327.038.519.13.289.14.522.373.661.662.093.192.12.377.13.518.01.126.01.272.01.408v4.028c0 .143 0 .296-.01.428a1.428 1.428 0 0 1-.144.542 1.417 1.417 0 0 1-.619.62c-.2.101-.393.131-.542.143-.132.011-.285.011-.428.011h-.729l-.064.093a7.863 7.863 0 0 1-3.168 2.682l-.128.06v1.255c0 .143 0 .296-.011.428a1.425 1.425 0 0 1-.144.542 1.417 1.417 0 0 1-.62.619c-.199.102-.393.131-.541.144-.132.01-.285.01-.428.01h-2.263c-.143 0-.296 0-.428-.01a1.428 1.428 0 0 1-.542-.144 1.417 1.417 0 0 1-.62-.62 1.427 1.427 0 0 1-.143-.541 5.468 5.468 0 0 1-.01-.428v-.59H11.75v.59c0 .143 0 .296-.01.428a1.425 1.425 0 0 1-.145.542 1.417 1.417 0 0 1-.619.619c-.199.102-.393.131-.542.144-.132.01-.285.01-.428.01H7.744c-.143 0-.296 0-.428-.01a1.429 1.429 0 0 1-.543-.144 1.417 1.417 0 0 1-.619-.62 1.428 1.428 0 0 1-.143-.541A5.507 5.507 0 0 1 6 21.09v-2.845l-.06-.061A7.812 7.812 0 0 1 3.71 13.5h-.377A3.167 3.167 0 0 1 1.75 7.59a.833.833 0 0 1 .835 1.443 1.5 1.5 0 0 0 .75 2.8h.376a7.832 7.832 0 0 1 3.557-5.759c-.066-.32-.1-.652-.1-.99Zm4.333-.25a7.82 7.82 0 0 0-2.66.463 3.25 3.25 0 0 1 6.484-.463H11.5Zm-.198 1.67a6.167 6.167 0 0 0-4.153 10.534c.088.087.22.22.31.368.08.13.133.26.169.408a1.942 1.942 0 0 1 .039.488v2.866H10.083v-.59c0-.143 0-.296.011-.428.012-.149.042-.343.144-.542.136-.267.352-.483.619-.62.2-.1.393-.13.542-.143.132-.01.285-.01.428-.01h1.68c.142 0 .295 0 .427.01.15.012.343.042.542.144.267.136.484.352.62.619.101.2.131.393.143.542.011.132.011.285.01.428v.49l.001.1H17.667V19.877c-.002-.172-.003-.438.081-.676a1.37 1.37 0 0 1 .69-.783c.09-.048.199-.098.307-.149l.015-.007a6.195 6.195 0 0 0 2.523-2.153c.089-.13.222-.327.39-.463.148-.119.302-.2.483-.254a1.97 1.97 0 0 1 .57-.06h.774v-4.166h-.133c-.163 0-.416.002-.645-.075a1.372 1.372 0 0 1-.806-.701 6.635 6.635 0 0 1-.142-.294l-.006-.014a6.183 6.183 0 0 0-1.224-1.76l-.027-.027c-.087-.087-.22-.22-.31-.368-.08-.13-.133-.26-.168-.408-.04-.168-.04-.344-.04-.456L20 7.032V5.605l-.128.036-2.767.791-.01.003c-.036.01-.093.026-.152.038a1.416 1.416 0 0 1-.314.027h-5.13c-.065 0-.132.001-.197.003Zm9.003-.974h-.002Zm-.316-.236V5.29ZM22.767 16.9l-.001.001Z',
      },
    ],
  },
  plusCircle: {
    viewbox: '0 0 22 22',
    paths: [
      {
        d: 'M11 22C4.9 22 0 17.1 0 11S4.9 0 11 0s11 4.9 11 11-4.9 11-11 11zm0-20c-5 0-9 4-9 9s4 9 9 9 9-4 9-9-4-9-9-9zm0 14c-.6 0-1-.4-1-1v-3H7c-.6 0-1-.4-1-1s.4-1 1-1h3V7c0-.6.4-1 1-1s1 .4 1 1v3h3c.6 0 1 .4 1 1s-.4 1-1 1h-3v3c0 .6-.4 1-1 1z',
      },
    ],
  },
  plus: {
    viewbox: '0 0 20 20',
    paths: [
      {
        d: 'M10 0c.8 0 1.5.7 1.5 1.5v7.1h7.1c.8 0 1.5.7 1.5 1.5s-.7 1.5-1.5 1.5h-7.1v7.1c0 .8-.7 1.5-1.5 1.5s-1.5-.7-1.5-1.5v-7.1h-7C.7 11.5 0 10.8 0 10s.7-1.5 1.5-1.5h7.1v-7C8.5.7 9.2 0 10 0z',
      },
    ],
  },
  pocket: {
    viewbox: '0 0 20 20',
    paths: [
      {
        d: 'M13.9 7.8c.3.3.3.8 0 1.1l-3.3 3.3c-.1.1-.3.2-.5.2s-.4-.1-.5-.2L6.1 8.9c-.3-.3-.3-.8 0-1.1s.8-.3 1.1 0l2.8 2.8 2.8-2.8c.3-.3.8-.3 1.1 0zm5.2-3.6v5c0 2.4-.9 4.7-2.7 6.4-1.7 1.7-4 2.7-6.4 2.7-1.2 0-2.4-.2-3.5-.7-1.1-.5-2.1-1.1-2.9-2-1.7-1.7-2.7-4-2.7-6.4v-5c0-.6.3-1.3.7-1.7s1.1-.7 1.7-.7h13.3c.6 0 1.3.3 1.7.7.5.4.8 1 .8 1.7zm-1.5 0c0-.2-.1-.5-.3-.6s-.4-.3-.6-.3H3.3c-.2 0-.5.1-.6.3s-.3.3-.3.6v5c0 2 .8 3.9 2.2 5.4.7.7 1.5 1.3 2.5 1.6.9.4 1.9.6 2.9.6 2 0 3.9-.8 5.4-2.2 1.4-1.4 2.2-3.3 2.2-5.4v-5z',
      },
    ],
  },
  questionCircle: {
    viewbox: '0 0 20 20',
    paths: [
      {
        d: 'M10 1.8c-4.5 0-8.2 3.7-8.2 8.2 0 4.5 3.7 8.2 8.2 8.2 4.5 0 8.2-3.7 8.2-8.2 0-4.5-3.7-8.2-8.2-8.2zM0 10C0 4.5 4.5 0 10 0s10 4.5 10 10-4.5 10-10 10S0 15.5 0 10zm10.2-3.6c-.4-.1-.8 0-1.2.2-.4.2-.7.6-.8 1-.2.4-.7.7-1.1.5-.5-.1-.8-.7-.6-1.1.3-.8.8-1.5 1.6-2 .7-.4 1.6-.6 2.5-.4.8.1 1.6.6 2.2 1.2.6.7.9 1.5.9 2.3 0 1.4-1 2.3-1.8 2.8-.4.3-.8.5-1.1.6-.1.1-.3.1-.4.1h-.1l-.3-.9.3.9c-.5.2-1-.1-1.2-.6-.2-.5.1-1 .6-1.1h.1c0 .1.1.1.2 0 .2-.1.5-.2.8-.4.6-.4 1-.9 1-1.3s-.2-.8-.4-1.2c-.4-.3-.7-.5-1.2-.6zm-1.1 8.1c0-.5.4-.9.9-.9s.9.4.9.9-.4.9-.9.9c-.5.1-.9-.4-.9-.9z',
      },
    ],
  },
  sad: {
    viewbox: '0 0 22 22',
    paths: [
      {
        d: 'M11 22C4.9 22 0 17.1 0 11S4.9 0 11 0s11 4.9 11 11-4.9 11-11 11zm0-20c-5 0-9 4-9 9s4 9 9 9 9-4 9-9-4-9-9-9zm4 14c-.3 0-.6-.1-.8-.4 0 0-1.3-1.6-3.2-1.6-1.9 0-3.2 1.6-3.2 1.6-.3.4-1 .5-1.4.2-.4-.3-.5-1-.2-1.4C6.3 14.3 8 12 11 12s4.7 2.3 4.8 2.4c.3.4.2 1.1-.2 1.4-.2.1-.4.2-.6.2zm-1-7c-.6 0-1-.4-1-1s.4-1 1-1 1 .4 1 1-.4 1-1 1zM8 9c-.5 0-1-.4-1-1s.4-1 1-1 1 .4 1 1-.4 1-1 1z',
      },
    ],
  },
  search: {
    viewbox: '0 0 20 20',
    paths: [
      {
        d: 'M19.7 18.3 16 14.6c1.2-1.5 2-3.5 2-5.6 0-5-4-9-9-9S0 4 0 9s4 9 9 9c2.1 0 4.1-.7 5.6-2l3.7 3.7c.4.4 1 .4 1.4 0 .4-.4.4-1 0-1.4zm-5.6-4.5-.1.1-.1.1c-1.3 1.3-3 2-4.9 2-3.9 0-7-3.1-7-7s3.1-7 7-7 7 3.1 7.1 6.9c0 1.9-.8 3.6-2 4.9z',
      },
    ],
  },
  send: {
    viewbox: '0 0 20 20',
    paths: [
      {
        d: 'M19.7.3c.2.2.3.6.2.9l-6.4 18.2c-.1.4-.4.6-.8.6s-.7-.2-.9-.5l-3.5-7.9L.5 8.1C.2 8 0 7.6 0 7.2s.3-.7.6-.8L18.8 0c.3-.1.7 0 .9.3zm-9.5 10.8 2.4 5.5 4.3-12.2-6.7 6.7zm5.4-8L3.4 7.4l5.5 2.4 6.7-6.7z',
      },
    ],
  },
  settings: {
    viewbox: '0 0 24 24',
    paths: [
      {
        d: 'M12 8c-2.2 0-4 1.8-4 4s1.8 4 4 4 4-1.8 4-4-1.8-4-4-4zm0 6c-1.1 0-2-.9-2-2s.9-2 2-2 2 .9 2 2-.9 2-2 2zm8.3 1.4c0-.1.1-.2.2-.3.2-.1.3-.1.5-.1.8 0 1.6-.3 2.1-.9s.9-1.3.9-2.1-.3-1.6-.9-2.1c-.5-.6-1.3-.9-2.1-.9h-.2c-.1 0-.3 0-.4-.1-.1 0-.1-.1-.2-.2 0-.1 0-.1-.1-.2s-.1-.2 0-.4c0-.1.1-.2.2-.4.3-.3.5-.6.7-1 .2-.4.2-.8.2-1.1s-.1-.8-.2-1.1c-.2-.4-.4-.7-.7-1-.3-.3-.6-.5-1-.7-.7-.3-1.6-.3-2.3 0-.4.2-.7.4-1 .7-.1.1-.2.2-.3.2h-.4c-.1-.1-.2-.1-.3-.2V3c0-.8-.3-1.6-.9-2.1C13-.3 11-.3 9.9.9 9.3 1.4 9 2.2 9 3v.2c0 .1 0 .3-.1.4 0 .1-.1.1-.2.2-.1 0-.1 0-.2.1s-.3.1-.4 0c-.1-.1-.2-.2-.4-.3-.3-.3-.6-.5-1-.7-.7-.3-1.5-.3-2.2 0-.4.2-.7.4-1 .6-.3.4-.5.7-.6 1.1-.2.3-.3.7-.3 1.1s.1.8.2 1.1c.2.4.4.7.7 1 .1.2.2.3.2.4 0 .1 0 .3-.1.4 0 .1-.1.2-.2.3-.1.1-.2.2-.4.2-.8 0-1.6.3-2.1.9-.6.5-.9 1.3-.9 2.1s.3 1.6.9 2.1c.6.6 1.3.9 2.1.9h.2c.1 0 .2 0 .4.1.1.1.2.2.2.3.1.1.1.3 0 .4 0 .1-.1.2-.2.4-.3.3-.5.6-.7 1-.2.4-.2.8-.2 1.1s.1.8.2 1.1c.2.4.4.7.7 1 .3.3.6.5 1 .6.7.3 1.6.3 2.3 0 .4-.2.7-.4 1-.7.1-.1.2-.2.3-.2.1 0 .3 0 .4.1.1 0 .2.1.3.2.1.2.2.3.2.5 0 .8.3 1.6.9 2.1.6.6 1.3.9 2.1.9s1.6-.3 2.1-.9.9-1.3.9-2.1v-.2c0-.1 0-.2.1-.4.1-.1.2-.2.3-.2.1-.1.2-.1.4 0 .1 0 .2.1.4.2.3.3.6.5 1 .7.7.3 1.6.3 2.3 0 .4-.2.7-.4 1-.7.3-.3.5-.6.6-1 .2-.4.2-.8.2-1.2s-.1-.8-.2-1.1c-.2-.4-.4-.7-.7-1-.1-.1-.2-.2-.2-.3-.1-.1 0-.3 0-.4zm-.8-2c-.4.3-.8.7-1 1.2-.2.5-.3 1-.2 1.5.1.5.3 1 .8 1.4.1.1.2.2.2.3 0 .1.1.2.1.4s0 .3-.1.4c-.1.1-.1.2-.2.3-.1.1-.2.2-.3.2-.2.1-.5.1-.8 0-.1-.1-.2-.1-.4-.3-.4-.4-.9-.6-1.4-.7-.5-.1-1.1 0-1.5.2-.5.2-.9.5-1.2 1-.3.4-.4.9-.4 1.5v.2c0 .3-.1.5-.3.7-.4.4-1 .4-1.4 0-.2-.2-.3-.4-.3-.7v-.1c0-.5-.2-1-.5-1.5-.3-.4-.7-.8-1.2-.9-.3-.2-.7-.2-1.1-.2h-.5c-.5.1-1 .3-1.4.8-.1.1-.2.2-.3.2-.2.1-.5.1-.8 0-.1-.1-.2-.1-.3-.2-.1-.1-.2-.2-.2-.3 0-.1-.1-.3-.1-.4s0-.3.1-.4c.1-.1.1-.2.2-.3l.1-.1c.4-.4.6-.9.7-1.4.1-.5 0-1.1-.2-1.5-.2-.5-.5-.9-1-1.2-.4-.3-.9-.4-1.5-.4H3c-.3 0-.5-.1-.7-.3-.2-.2-.3-.5-.3-.7s.1-.5.3-.7c.2-.2.4-.3.7-.3h.1c.5 0 1-.2 1.5-.5.4-.3.8-.8.9-1.2.2-.5.3-1 .2-1.5-.1-.5-.3-1-.8-1.4-.1-.2-.1-.3-.2-.4-.1-.1-.1-.3-.1-.4 0-.1 0-.3.1-.4.1-.1.1-.2.2-.3.1-.1.2-.2.3-.2.2-.1.5-.1.8 0 .1.1.2.1.4.3.4.4.9.6 1.4.7.5.1.9 0 1.3-.1.1 0 .2 0 .3-.1.5-.2.9-.5 1.2-1 .2-.4.4-.9.4-1.4V3c0-.3.1-.5.3-.7.4-.4 1-.4 1.4 0 .2.2.3.4.3.8 0 .5.2 1 .4 1.5.3.4.7.8 1.2 1 .5.2 1 .3 1.5.2.5-.1 1-.3 1.4-.8.1-.1.2-.2.3-.2.2-.1.5-.1.8 0 .1.1.2.1.3.2.1.1.2.2.2.3.1.1.1.3.1.4s0 .3-.1.4c-.1.1-.1.2-.3.4-.4.4-.6.9-.7 1.4-.1.5 0 .9.1 1.3 0 .1 0 .2.1.3.2.5.5.9 1 1.2.4.3.9.4 1.5.4h.2c.3 0 .5.1.7.3.2.2.3.4.3.7s-.1.5-.3.7c-.2.2-.4.3-.8.3-.5-.1-1 .1-1.4.3z',
      },
    ],
  },
  share: {
    viewbox: '0 0 20 20',
    paths: [
      {
        d: 'M10 0c.2 0 .5.1.6.3l3.6 3.6c.4.4.4.9 0 1.3s-.9.4-1.3 0l-2.1-2.1v9.6c0 .5-.4.9-.9.9s-.9-.4-.9-.9V3.1L7 5.2c-.4.4-.9.4-1.3 0s-.4-.9 0-1.3L9.3.3c.2-.2.5-.3.7-.3zM2.7 9.1c.5 0 .9.4.9.9v7.3c0 .2.1.5.3.6.2.2.4.3.6.3h10.9c.2 0 .5-.1.6-.3s.3-.4.3-.6V10c0-.5.4-.9.9-.9s.9.4.9.9v7.3c0 .7-.3 1.4-.8 1.9s-1.1.8-1.8.8h-11a2.732 2.732 0 0 1-2.7-2.7V10c0-.5.4-.9.9-.9z',
      },
    ],
  },
  sheet: {
    viewbox: '0 0 20 20',
    paths: [
      {
        d: 'M11.667 1.667H5a1.667 1.667 0 0 0-1.667 1.666v13.334A1.667 1.667 0 0 0 5 18.332h10a1.667 1.667 0 0 0 1.667-1.666v-10m-5-5 5 5m-5-5v5h5m-3.334 4.166H6.667m6.666 3.333H6.667M8.333 7.5H6.667',
        strokeWidth: '2',
        strokeLinecap: 'round',
        strokeLinejoin: 'round',
      },
    ],
  },
  smartphone: {
    viewbox: '0 0 16 22',
    paths: [
      {
        fillRule: 'evenodd',
        clipRule: 'evenodd',
        d: 'M3 2a1 1 0 0 0-1 1v16a1 1 0 0 0 1 1h10a1 1 0 0 0 1-1V3a1 1 0 0 0-1-1H3ZM0 3a3 3 0 0 1 3-3h10a3 3 0 0 1 3 3v16a3 3 0 0 1-3 3H3a3 3 0 0 1-3-3V3Zm7 14a1 1 0 0 1 1-1h.01a1 1 0 1 1 0 2H8a1 1 0 0 1-1-1Z',
      },
    ],
  },
  smile: {
    viewbox: '0 0 20 20',
    paths: [
      {
        d: 'M11.8 7.5c0-.4.3-.8.7-.8.4 0 .8.3.8.8s-.3.8-.8.8-.7-.4-.7-.8zm-4.3.7c.4 0 .8-.3.8-.8s-.4-.7-.8-.7-.7.3-.7.8.3.7.7.7zm5.2 3s-1.1 1.4-2.7 1.4c-1.7 0-2.7-1.3-2.7-1.4-.2-.3-.7-.4-1-.1-.3.2-.4.7-.1 1.1.1.1 1.5 2 3.9 2s3.9-1.9 3.9-2c.2-.3.2-.8-.1-1-.4-.4-.9-.3-1.2 0zm6.4-1.2c0 5-4.1 9.1-9.1 9.1S.9 15 .9 10 5 .9 10 .9 19.1 5 19.1 10zm-1.5 0c0-4.2-3.4-7.6-7.6-7.6S2.4 5.8 2.4 10s3.4 7.6 7.6 7.6 7.6-3.4 7.6-7.6z',
      },
    ],
  },
  spaceship: {
    viewbox: '0 0 22 22',
    paths: [
      {
        d: 'M21.2.8c-.6-.6-1.6-.9-2.4-.7l-4.4.9c-.8.2-1.5.4-2.1.8-.6.3-1.2.8-1.7 1.3L8.1 5.6H5c-.6 0-1.1.2-1.5.6l-3 3.1c-.4.4-.5 1-.4 1.5.2.5.6 1 1.1 1.1l3 .7c-.1 1.1.2 2.1.8 3l-1.2 1.2c-.4.4-.4 1 0 1.4.2.2.5.3.7.3s.5-.1.7-.3L6.4 17c.8.5 1.7.8 2.7.8h.3l.7 3c.1.5.5 1 1.1 1.1.1 0 .3.1.4.1.4 0 .8-.2 1.1-.5l3.1-3.1c.4-.4.6-.9.6-1.5v-3.1l2.5-2.5c.5-.5.9-1.1 1.3-1.7.4-.6.7-1.3.8-2l.9-4.3c.2-1 0-1.9-.7-2.5zm-2 1.2h.1c.2 0 .4.1.5.2.1.1.2.3.2.6l-.9 4.3c-1.2-1.6-2.6-3-4.2-4.2l4.3-.9zM5 7.6h1.2c-.7.9-1.2 1.9-1.6 3.1l-2.1-.5L5 7.6zm6.9 12-.5-2.1c1.1-.3 2.1-.9 3-1.6v1.2l-2.5 2.5zm2.1-6c-1.2 1.2-2.8 2-4.5 2.2-.6.1-1.1 0-1.6-.2l5.2-5.2c.4-.4.4-1 0-1.4s-1-.4-1.4 0l-5.2 5.2c-.2-.5-.3-1.1-.2-1.7.2-1.7 1-3.3 2.2-4.5L12 4.5c.2-.2.5-.5.8-.7 2.1 1.5 3.9 3.3 5.4 5.4-.2.3-.4.6-.7.8L14 13.6z',
      },
    ],
  },
  star: {
    viewbox: '0 0 22 22',
    paths: [
      {
        fillRule: 'evenodd',
        clipRule: 'evenodd',
        d: 'M11 0a1 1 0 0 1 .897.557l2.857 5.79 6.39.934a1 1 0 0 1 .554 1.705l-4.623 4.503 1.09 6.362a1 1 0 0 1-1.45 1.054L11 17.9l-5.715 3.005a1 1 0 0 1-1.45-1.054l1.09-6.362L.303 8.986a1 1 0 0 1 .553-1.705l6.39-.935L10.104.557A1 1 0 0 1 11 0Zm0 3.26L8.807 7.702a1 1 0 0 1-.752.546l-4.907.718 3.55 3.457a1 1 0 0 1 .288.885l-.838 4.883 4.387-2.307a1 1 0 0 1 .93 0l4.387 2.307-.838-4.883a1 1 0 0 1 .288-.885l3.55-3.457-4.907-.718a1 1 0 0 1-.752-.546L11 3.259Z',
      },
    ],
  },
  target: {
    viewbox: '0 0 21 20',
    paths: [
      {
        d: 'M10.5 1.8C6 1.8 2.3 5.5 2.3 10c0 4.5 3.7 8.2 8.2 8.2 4.5 0 8.2-3.7 8.2-8.2 0-4.5-3.7-8.2-8.2-8.2zM.5 10C.5 4.5 5 0 10.5 0s10 4.5 10 10-4.5 10-10 10-10-4.5-10-10zm10-4.5C8 5.5 6 7.5 6 10s2 4.5 4.5 4.5 4.5-2 4.5-4.5-2-4.5-4.5-4.5zM4.1 10c0-3.5 2.8-6.4 6.4-6.4 3.5 0 6.4 2.8 6.4 6.4 0 3.5-2.8 6.4-6.4 6.4-3.5 0-6.4-2.9-6.4-6.4zm6.4-.9c-.5 0-.9.4-.9.9s.4.9.9.9.9-.4.9-.9-.4-.9-.9-.9zm-2.7.9c0-1.5 1.2-2.7 2.7-2.7 1.5 0 2.7 1.2 2.7 2.7 0 1.5-1.2 2.7-2.7 2.7-1.5 0-2.7-1.2-2.7-2.7z',
      },
    ],
  },
  telegram: {
    viewbox: '0 0 32 32',
    paths: [
      {
        d: 'M32 16c0 8.8-7.2 16-16 16S0 24.8 0 16 7.2 0 16 0s16 7.2 16 16zm-9.3-6.3-15.4 6c-1.1.4-1 1-.2 1.3l3.9 1.2 9.2-5.8c.4-.3.8-.1.5.2l-7.4 6.7-.3 4c.4 0 .6-.2.8-.4l1.9-1.9 4 2.9c.7.4 1.3.2 1.4-.7L23.9 11c.2-1.1-.4-1.6-1.2-1.3z',
      },
    ],
  },
  tick: {
    viewbox: '0 0 24 24',
    paths: [
      {
        d: 'M21.5 2.5 7.2 15.7l-3.8-3.9c-.7-.6-1.8-.7-2.6-.1s-1 1.5-.5 2.3l4.5 7c.4.6 1.2 1 2.1 1 .8 0 1.6-.4 2-1 .7-.9 14.4-16.5 14.4-16.5 1.8-1.8-.4-3.3-1.8-2z',
      },
    ],
  },
  token: {
    viewbox: '0 0 20.9 20',
    paths: [
      {
        d: 'M10.5 1.8C6 1.8 2.3 5.5 2.3 10c0 4.5 3.7 8.2 8.2 8.2 4.5 0 8.2-3.7 8.2-8.2-.1-4.5-3.7-8.2-8.2-8.2zM.5 10C.5 4.5 5 0 10.5 0s10 4.5 10 10-4.5 10-10 10c-5.6 0-10-4.5-10-10zm6.3-2.7c0-.5.4-.9.9-.9h5.5c.5 0 .9.4.9.9v5.5c0 .5-.4.9-.9.9H7.7c-.5 0-.9-.4-.9-.9V7.3zm1.8.9v3.6h3.6V8.2H8.6z',
      },
    ],
  },
  trash: {
    viewbox: '0 0 20 20',
    paths: [
      {
        d: 'M10.9 14.5V9.1c0-.5.4-.9.9-.9s.9.4.9.9v5.5c0 .5-.4.9-.9.9s-.9-.5-.9-1zm-2.7 1c.5 0 .9-.4.9-.9V9.1c0-.5-.4-.9-.9-.9s-.9.4-.9.9v5.5c0 .4.4.9.9.9zm9.9-11.9h-3.6v-.9A2.732 2.732 0 0 0 11.8 0H8.2a2.732 2.732 0 0 0-2.7 2.7v.9H1.9c-.5 0-.9.4-.9.9s.4.9.9.9h.9v11.8c0 .7.3 1.4.8 1.9.5.6 1.2.9 1.9.9h9a2.732 2.732 0 0 0 2.7-2.7V5.5h.9c.5 0 .9-.5.9-1s-.4-.9-.9-.9zM7.3 2.3c0-.2.1-.5.3-.6.1-.2.4-.3.6-.3h3.6c.2 0 .5.1.6.3.2.2.3.4.3.6v.9H7.3v-.9zm8.1 14.6c0 .2-.1.5-.3.6-.2.2-.4.3-.6.3h-9c-.2 0-.5-.1-.6-.3-.2-.2-.3-.4-.3-.6V5h10.8v11.9z',
      },
    ],
  },
  tray: {
    viewbox: '0 0 22 22',
    paths: [
      {
        d: 'M19 20H3c-.8 0-1.6-.3-2.1-.9-.6-.5-.9-1.3-.9-2.1v-6.2s0-.2.1-.2l3.4-6.9c.2-.5.6-.9 1.1-1.2.5-.3 1.1-.5 1.6-.5h9.5c.6 0 1.1.2 1.6.5s.9.7 1.1 1.2l3.4 6.9c0 .1.1.2.1.2V17c0 .8-.3 1.6-.9 2.1s-1.2.9-2 .9zM2 12v5c0 .3.1.5.3.7.2.2.4.3.7.3h16c.3 0 .5-.1.7-.3s.3-.4.3-.7v-5h-4.5l-1.7 2.6c-.2.2-.5.4-.8.4H9c-.3 0-.6-.2-.8-.4L6.5 12H2zm7.5 1h2.9l1.7-2.6c.2-.3.5-.4.8-.4h4.4l-2.7-5.4c-.1-.2-.2-.3-.4-.4-.1-.1-.3-.2-.4-.2H6.2c-.1 0-.3.1-.5.1s-.3.3-.4.5L2.6 10H7c.3 0 .6.2.8.4L9.5 13z',
      },
    ],
  },
  upload: {
    viewbox: '0 0 20 20',
    paths: [
      {
        d: 'M10 18.3c-.5 0-.8-.4-.8-.8V12l-1.9 1.9c-.3.3-.9.3-1.2 0-.3-.3-.3-.9 0-1.2l3.3-3.3c.1-.1.2-.1.2-.2.1 0 .2-.1.3-.1.1 0 .2 0 .3.1.1 0 .2.1.3.2l3.3 3.3c.3.3.3.9 0 1.2-.3.3-.9.3-1.2 0L10.8 12v5.5c0 .5-.3.8-.8.8zm7-2.1c-.3 0-.6-.2-.7-.4-.2-.4-.1-.9.3-1.1.6-.4 1.2-.9 1.5-1.6s.4-1.4.2-2.2c-.3-.8-.7-1.4-1.3-1.9-.6-.5-1.3-.7-2-.7h-1c-.4 0-.7-.3-.8-.6-.2-.8-.6-1.6-1.2-2.3-.6-.7-1.3-1.2-2.1-1.6s-1.7-.5-2.6-.5c-.9.1-1.8.3-2.5.7-.8.4-1.5 1-2 1.7s-.9 1.5-1 2.4c-.2.9-.2 1.8.1 2.6s.7 1.6 1.2 2.3c.3.3.3.9-.1 1.2-.3.3-.9.3-1.2-.1-.7-.8-1.3-1.9-1.6-2.9C0 10.1-.1 8.9.1 7.8c.2-1.1.7-2.2 1.3-3.1C2.1 3.8 3 3.1 4 2.5c1-.5 2.1-.8 3.2-.8s2.3.2 3.3.6c1 .5 2 1.1 2.7 2 .6.7 1.1 1.5 1.4 2.4h.4c1.1 0 2.2.4 3.1 1.1s1.5 1.6 1.8 2.7.2 2.2-.3 3.2c-.4 1-1.2 1.9-2.2 2.4-.1 0-.3.1-.4.1z',
      },
    ],
  },
  userCheck: {
    viewbox: '0 0 20 20',
    paths: [
      {
        d: 'M13.3 18.2c-.4 0-.8-.3-.8-.8v-1.7c0-.7-.3-1.3-.8-1.8s-1.1-.8-1.8-.8H4.2c-.7 0-1.3.3-1.8.8s-.8 1.1-.8 1.8v1.7c0 .4-.3.8-.8.8s-.8-.3-.8-.8v-1.7c0-1.1.4-2.1 1.2-2.9.8-.8 1.8-1.2 2.9-1.2H10c1.1 0 2.1.4 2.9 1.2s1.2 1.8 1.2 2.9v1.7c0 .5-.4.8-.8.8zm2.5-6.6c-.2 0-.4-.1-.5-.2l-1.7-1.7c-.3-.3-.3-.8 0-1.1s.8-.3 1.1 0l1.1 1.1L18.6 7c.3-.3.8-.3 1.1 0s.3.8 0 1.1l-3.3 3.3c-.2.1-.4.2-.6.2zM7.1 9.9C4.8 9.9 3 8.1 3 5.8s1.8-4.1 4.1-4.1 4.1 1.8 4.1 4.1-1.9 4.1-4.1 4.1zm0-6.7c-1.4 0-2.6 1.2-2.6 2.6s1.2 2.6 2.6 2.6 2.6-1.2 2.6-2.6-1.2-2.6-2.6-2.6z',
      },
    ],
  },
  userCross: {
    viewbox: '0 0 20 20',
    paths: [
      {
        d: 'M7.1 3.3c-1.4 0-2.5 1.1-2.5 2.5s1.1 2.5 2.5 2.5 2.5-1.1 2.5-2.5-1.1-2.5-2.5-2.5zM2.9 5.8c0-2.3 1.9-4.2 4.2-4.2 2.3 0 4.2 1.9 4.2 4.2S9.4 10 7.1 10c-2.3 0-4.2-1.9-4.2-4.2zm11.5.3c.3-.3.9-.3 1.2 0l1.5 1.5 1.5-1.5c.3-.3.9-.3 1.2 0 .3.3.3.9 0 1.2l-1.5 1.5 1.5 1.5c.3.3.3.9 0 1.2-.3.3-.9.3-1.2 0L17.1 10l-1.5 1.5c-.3.3-.9.3-1.2 0-.3-.3-.3-.9 0-1.2l1.5-1.5-1.5-1.5c-.3-.4-.3-.9 0-1.2zM1.2 12.9c.8-.8 1.8-1.2 2.9-1.2H10c1.1 0 2.2.4 2.9 1.2.8.8 1.2 1.8 1.2 2.9v1.7c0 .5-.4.8-.8.8-.5 0-.8-.4-.8-.8v-1.7c0-.7-.3-1.3-.7-1.8-.5-.5-1.1-.7-1.8-.7H4.2c-.7 0-1.3.3-1.8.7-.5.5-.7 1.1-.7 1.8v1.7c0 .5-.4.8-.8.8-.5 0-.9-.3-.9-.8v-1.7c0-1.1.4-2.1 1.2-2.9z',
      },
    ],
  },
  userLeft: {
    viewbox: '0 0 26 23',
    paths: [
      {
        fillRule: 'evenodd',
        clipRule: 'evenodd',
        d: 'M10.333 1.833a4.417 4.417 0 1 0 0 8.834 4.417 4.417 0 0 0 0-8.834ZM4.25 6.25a6.083 6.083 0 1 1 12.167 0 6.083 6.083 0 0 1-12.167 0Zm17.173 8.16a.833.833 0 0 1 0 1.18l-2.078 2.077h4.988a.833.833 0 1 1 0 1.666h-4.988l2.078 2.078a.833.833 0 0 1-1.179 1.178l-3.5-3.5a.833.833 0 0 1 0-1.178l3.5-3.5a.833.833 0 0 1 1.179 0Zm-14.167.34h5.41a.833.833 0 0 1 0 1.667h-5.25c-1.688 0-2.348.009-2.862.165a3.833 3.833 0 0 0-2.556 2.555c-.156.514-.165 1.174-.165 2.863a.833.833 0 0 1-1.666 0v-.161c0-1.474 0-2.403.236-3.186a5.5 5.5 0 0 1 3.667-3.666c.782-.238 1.712-.237 3.186-.237Z',
      },
    ],
  },
  userMinus: {
    viewbox: '0 0 20 20',
    paths: [
      {
        d: 'M13.3 18.2c-.4 0-.8-.3-.8-.8v-1.7c0-.7-.3-1.3-.8-1.8s-1.1-.8-1.8-.8H4.2c-.7 0-1.3.3-1.8.8s-.8 1.1-.8 1.8v1.7c0 .4-.3.8-.8.8s-.8-.3-.8-.8v-1.7c0-1.1.4-2.1 1.2-2.9.8-.8 1.8-1.2 2.9-1.2H10c1.1 0 2.1.4 2.9 1.2s1.2 1.8 1.2 2.9v1.7c0 .5-.4.8-.8.8zm5.9-8.3h-5c-.4 0-.8-.3-.8-.8s.3-.8.8-.8h5c.4 0 .8.3.8.8s-.4.8-.8.8zm-12.1 0C4.8 9.9 3 8.1 3 5.8s1.8-4.1 4.1-4.1 4.1 1.8 4.1 4.1-1.9 4.1-4.1 4.1zm0-6.7c-1.4 0-2.6 1.2-2.6 2.6s1.2 2.6 2.6 2.6 2.6-1.2 2.6-2.6-1.2-2.6-2.6-2.6z',
      },
    ],
  },
  userPlus: {
    viewbox: '0 0 20 20',
    paths: [
      {
        d: 'M7.1 3.3c-1.4 0-2.5 1.1-2.5 2.5s1.1 2.5 2.5 2.5 2.5-1.1 2.5-2.5c0-1.3-1.1-2.5-2.5-2.5zM2.9 5.8c0-2.3 1.9-4.2 4.2-4.2 2.3 0 4.2 1.9 4.2 4.2 0 2.3-1.9 4.2-4.2 4.2-2.3 0-4.2-1.9-4.2-4.2zm13.8 0c.5 0 .8.4.8.8v1.7h1.7c.5 0 .8.4.8.8s-.4.9-.8.9h-1.7v1.7c0 .5-.4.8-.8.8-.5 0-.8-.4-.8-.8V10h-1.7c-.5 0-.8-.4-.8-.8s.4-.8.8-.8h1.7V6.7c-.1-.5.3-.9.8-.9zM1.2 12.9c.8-.8 1.8-1.2 2.9-1.2H10c1.1 0 2.2.4 2.9 1.2.8.8 1.2 1.8 1.2 2.9v1.7c0 .5-.4.8-.8.8-.5 0-.8-.4-.8-.8v-1.7c0-.7-.3-1.3-.7-1.8-.5-.5-1.1-.7-1.8-.7H4.2c-.7 0-1.3.3-1.8.7s-.7 1.1-.7 1.8v1.7c0 .5-.4.8-.8.8-.5 0-.9-.3-.9-.8v-1.7c0-1.1.4-2.1 1.2-2.9z',
      },
    ],
  },
  userUp: {
    viewbox: '0 0 26 23',
    paths: [
      {
        fillRule: 'evenodd',
        clipRule: 'evenodd',
        d: 'M10.333 1.833a4.417 4.417 0 1 0 0 8.834 4.417 4.417 0 0 0 0-8.834ZM4.25 6.25a6.083 6.083 0 1 1 12.167 0 6.083 6.083 0 0 1-12.167 0Zm15.994 8.16a.833.833 0 0 1 1.179 0l3.5 3.5a.833.833 0 0 1-1.179 1.18l-2.077-2.078V22A.833.833 0 0 1 20 22v-4.988l-2.077 2.077a.833.833 0 1 1-1.179-1.178l3.5-3.5Zm-12.988.34h5.41a.833.833 0 0 1 0 1.667h-5.25c-1.688 0-2.348.009-2.862.165a3.833 3.833 0 0 0-2.556 2.555c-.156.514-.165 1.174-.165 2.863a.833.833 0 0 1-1.666 0v-.161c0-1.474 0-2.403.236-3.186a5.5 5.5 0 0 1 3.667-3.666c.782-.238 1.712-.237 3.186-.237Z',
      },
    ],
  },
  user: {
    viewbox: '0 0 20 20',
    paths: [
      {
        d: 'M18.4 20c-.3 0-.5-.2-.5-.5v-2.1c0-1-.4-1.9-1.1-2.6-.7-.7-1.6-1.1-2.6-1.1H5.8c-1 0-1.9.4-2.6 1.1-.7.7-1.1 1.6-1.1 2.6v2.1c0 .3-.2.5-.5.5s-.5-.2-.5-.5v-2.1c0-1.3.5-2.5 1.4-3.4.9-.9 2.1-1.4 3.4-1.4h8.4c1.3 0 2.5.5 3.4 1.4.9.9 1.4 2.1 1.4 3.4v2.1c-.2.3-.4.5-.7.5zM10 9.5c-2.6 0-4.7-2.1-4.7-4.7S7.4 0 10 0s4.7 2.1 4.7 4.7-2.1 4.8-4.7 4.8zm0-8.4c-2 0-3.7 1.6-3.7 3.7S8 8.4 10 8.4s3.7-1.6 3.7-3.7S12 1.1 10 1.1z',
      },
    ],
  },
  users: {
    viewbox: '0 0 24 24',
    paths: [
      {
        d: 'M23 22c-.6 0-1-.4-1-1v-2c0-.7-.2-1.3-.6-1.8-.4-.5-1-.9-1.6-1.1-.5-.1-.9-.7-.7-1.2.1-.5.7-.9 1.2-.7 1.1.3 2 .9 2.7 1.8.7.9 1 2 1 3.1v2c0 .5-.4.9-1 .9zm-6 0c-.6 0-1-.4-1-1v-2c0-.8-.3-1.6-.9-2.1S13.8 16 13 16H5c-.8 0-1.6.3-2.1.9-.6.5-.9 1.3-.9 2.1v2c0 .6-.4 1-1 1s-1-.4-1-1v-2c0-1.3.5-2.6 1.5-3.5.9-1 2.2-1.5 3.5-1.5h8c1.3 0 2.6.5 3.5 1.5.9.9 1.5 2.2 1.5 3.5v2c0 .6-.4 1-1 1zM9 12c-2.8 0-5-2.2-5-5s2.2-5 5-5 5 2.2 5 5-2.2 5-5 5zm0-8C7.3 4 6 5.3 6 7s1.3 3 3 3 3-1.3 3-3-1.3-3-3-3zm7 7.9c-.4 0-.9-.3-1-.8-.1-.5.2-1.1.7-1.2.6-.2 1.2-.5 1.6-1.1S18 7.7 18 7s-.2-1.3-.6-1.8c-.4-.5-1-.9-1.6-1.1-.6-.1-.9-.7-.8-1.2s.7-.9 1.2-.7c1.1.3 2 .9 2.7 1.8.7.9 1 2 1 3.1s-.4 2.2-1 3.1c-.7.9-1.6 1.5-2.7 1.8 0-.1-.1-.1-.2-.1z',
      },
    ],
  },
  website: {
    viewbox: '0 0 32 32',
    paths: [
      {
        d: 'M16 32C7.2 32 0 24.8 0 16S7.2 0 16 0s16 7.2 16 16-7.2 16-16 16zm7-14.9c-.3 4.5-1.9 8.8-4.5 12.4 6-1.1 10.7-6.2 11.2-12.4H23zm-20.7 0c.5 6.2 5.2 11.3 11.2 12.4-2.6-3.6-4.2-7.9-4.5-12.4H2.3zm8.9 0c.3 4.4 2 8.6 4.8 12.1 2.8-3.4 4.5-7.6 4.8-12.1h-9.6zM23 14.9h6.7c-.5-6.2-5.1-11.3-11.2-12.4 2.7 3.6 4.2 7.9 4.5 12.4zm-11.8 0h9.6c-.3-4.4-2-8.6-4.8-12.1-2.8 3.5-4.5 7.7-4.8 12.1zm-8.9 0H9c.3-4.5 1.9-8.8 4.5-12.4C7.4 3.6 2.8 8.7 2.3 14.9z',
      },
    ],
  },
  youtube: {
    viewbox: '0 0 32 22',
    paths: [
      {
        d: 'M30.6 2.1C29.7.6 28.8.3 26.9.2 25 .1 20.2 0 16 0S7 .1 5.1.2C3.2.3 2.2.6 1.4 2.1.5 3.7 0 6.3 0 11s.5 7.3 1.4 8.9c.9 1.5 1.8 1.8 3.7 2 1.9 0 6.7.1 10.9.1s9-.1 10.9-.2c1.9-.1 2.9-.4 3.7-2 .9-1.5 1.4-4.2 1.4-8.9 0-4.6-.5-7.2-1.4-8.8zM12 17V5l10 6-10 6z',
      },
    ],
  },
};
export default ui;
